


const routers = [

  {path: '/login',               name: 'login',                component:()=>import('../views/others/login/login.vue')},
  {path: '/mrecruitInfo',        name: 'mrecruitInfo',         component:()=>import('../views/others/recruitInfo/recruitInfo.vue'), meta:{keepAlive: true, title:'胜通和科技鲸蓝平台招聘系统'}},
  {path: '/recruitDetail',       name: 'recruitDetail',        component:()=>import('../views/others/recruitInfo/recruitDetail.vue')},
  {path: '/resume',              name: 'resume',               component:()=>import('../views/others/recruitInfo/resume.vue')},
  {path: '/homeNoLogin',         name: 'homeNoLogin',          component:()=>import('../views/others/home/homeNoLogin.vue')},
  {path: '/privacyPolicy',       name: 'privacyPolicy',        component:()=>import('../views/others/privacyPolicyStatement/privacyPolicy.vue'),meta:{keepAlive: true, title:'胜通和科技鲸蓝平台隐私权政策声明'}},
  {path: '/selectfunction',      name: 'selectfunction',       component:()=>import('../views/tools/selectfunction.vue')},//八个功能的入口
  {path: '/fenggefunction',      name: 'fenggefunction',       component:()=>import('../views/tools/fenggefunction.vue')},//表的分割
  {path: '/excelcontrast',       name: 'excelcontrast',        component:()=>import('../views/tools/excelcontrast.vue')},//表的对比
  {path: '/businessservice',     name: 'businessservice',      component:()=>import('../views/financeSystem/businessservice/businessservice.vue')},//功能八
  {path: '/formoflandtax',       name: 'formoflandtax',        component:()=>import('../views/tools/formOfLandTax.vue')},
  {path: '/checkbeforecdcstaff', name: 'checkbeforecdcstaff',  component:()=>import('../views/tools/checkBeforeICDCStaff.vue')},
  {path: '/checkaftercdcstaff',  name: 'checkaftercdcstaff',   component:()=>import('../views/tools/checkAfterICDCStaff.vue')},
  {path: '/wagecheckshebao',     name: 'wagecheckshebao',      component:()=>import('../views/tools/wageCheckSheBao.vue')},
  {path: '/changeICDCStaff',     name: 'changeICDCStaff',      component:()=>import('../views/tools/changeICDCStaff.vue')},
  {path: '/sendEmail',           name: 'sendEmail',            component:()=>import('../views/tools/sendEmail.vue')},
  {path: '/checkFBWStaff',       name: 'checkFBWStaff',        component:()=>import('../views/tools/checkFBWStaff.vue')},
  {path: '/checkIdCard',         name: 'checkIdCard',          component:()=>import('../views/tools/checkIdCard.vue')},
  {path: '/mprotitoyy',          name: 'mprotitoyy',           component:()=>import('../views/tools/mprotiToYY.vue')},
  {path: '/operationDocument',                     name: 'operationDocument',                      component:()=>import('../views/helpCenterSystem/operationDocumentModule/operationDocument.vue')},
  {path: '/operationDocumentOverall',              name: 'operationDocumentOverall',               component:()=>import('../views/helpCenterSystem/operationDocumentModule/operationDocumentOverall.vue')},
  {path: '/operationDocumentOverallList',          name: 'operationDocumentOverallList',           component:()=>import('../views/helpCenterSystem/operationDocumentModule/operationDocumentOverallList.vue')},
  {path: '/operationDocumentOverallListDetails',   name: 'operationDocumentOverallListDetails',    component:()=>import('../views/helpCenterSystem/operationDocumentModule/operationDocumentOverallListDetails.vue')},
  //业务员手机端
  {path: '/mobileHome',           name: 'mobileHome',            component:()=>import('../mobile/home/mobileHome.vue')},


  {//工作台
    path: '/workbench',                      name: 'workbench',                    component:()=>import('../components/stonghrSysMenu/workbench.vue'), redirect:'workbench/workingtable',
    children: [
      {path: 'welcome',                      name: 'welcome',                      component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'programming1',                 name: 'programming1',                 component:()=>import('../views/others/programming/programming.vue')},
      {path: 'workingTable',                 name: 'workingTable',                 component:()=>import('../views/staffSystem/workingtable/workingTable.vue')},
      {path: 'workingTableNew',              name: 'workingTableNew',              component:()=>import('../views/staffSystem/workingtable/workingTableNew.vue')},
    ]
  },


  {//外包业务系统
    path: '/personnelBusinessSystem',               name: 'personnelBusinessSystem',             component:()=>import('../components/stonghrSysMenu/personnelBusinessSystem.vue'),
    children: [
      {
        path: 'staffXxxManger',
        name: 'staffXxxManger',
        component:()=>import('../views/staffSystem/staffXxxModule/staffXxxManage.vue'),meta:['员工管理','员工Xxx管理']
      },

      {path: 'staffReimburseFatherList',            name: 'staffReimburseFatherList',            component:()=>import('../views/staffSystem/staffReimburseModule/staffReimburseGroupList.vue'),meta:['薪酬管理','员工报销管理']},
      {path: 'wfw_test',                            name: 'wfw_test',                            component:()=>import('../views/customerServiceSystem/staffContractInfo/wfw_test.vue')},
      {path: 'wfw_test2',                           name: 'wfw_test2',                           component:()=>import('../views/customerServiceSystem/staffContractInfo/wfw_test2.vue')},
      {path: 'welcome',                             name: 'welcome',                             component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'programming4',                        name: 'programming4',                        component:()=>import('../views/others/programming/programming.vue')},
      {path: 'staffinfo',                           name: 'staffinfo',                           component:()=>import('../views/staffSystem/staffManageModule/staffInfo/staffinfo.vue'),meta:['员工信息','员工花名册']},
      {path: 'staffInfoAbnormalList',               name: 'staffInfoAbnormalList',               component:()=>import('../views/staffSystem/staffManageModule/staffInfo/staffInfoAbnormalList/staffInfoAbnormalList.vue'),meta:['员工信息','异常名单']},
      {path: 'staffOverseasVisa',                   name: 'staffOverseasVisa',                   component:()=>import('../views/staffSystem/staffManageModule/staffInfo/staffOverseasVisa.vue'),meta:['员工信息','海外签证信息']},
      {path: 'staffInfoDetail/:id',                 name: 'staffInfoDetail',                     component:()=>import('../views/staffSystem/staffManageModule/staffInfo/staffInfoDetail/staffInfoDetail.vue')},
      {path: 'freezeinfo',                          name: 'freezeinfo',                          component:()=>import('../views/staffSystem/staffManageModule/freeze/freezeinfo.vue'),meta:['员工管理','作废信息']},//作废信息
      {path: 'commercialInsurancePolicy',           name: 'commercialInsurancePolicy',           component:()=>import('../views/staffSystem/commercialInsurance/commercialInsurancePolicy/commercialInsurancePolicy.vue')},//商保包配置
      {path: 'commercialInsuranceProject',          name: 'commercialInsuranceProject',          component:()=>import('../views/staffSystem/commercialInsurance/commercialInsuranceProject/commercialInsuranceProject.vue'),meta:['商保管理','商保包配置']},//商保
      {path: 'commercialInsuranceProjectZY',        name: 'commercialInsuranceProjectZY',        component:()=>import('../views/staffSystem/commercialInsurance/commercialInsuranceProject/commercialInsuranceProjectZY.vue'),meta:['商保管理','商保包维护']},//商保
      {path: 'commercialInsuranceStaffInfo',        name: 'commercialInsuranceStaffInfo',        component:()=>import('../views/staffSystem/commercialInsurance/commercialInsuranceStaffInfo/commercialInsuranceStaffInfo.vue'),meta:['商保管理','商保维护-业务员']},//商保
      {path: 'commercialInsuranceStaffInfoZY',      name: 'commercialInsuranceStaffInfoZY',      component:()=>import('../views/staffSystem/commercialInsurance/commercialInsuranceZY/commercialInsuranceStaffInfoZY.vue'),meta:['商保管理','商保处理-专员']},//商保
      {path: 'commercialInsuranceReal',             name: 'commercialInsuranceReal',             component:()=>import('../views/staffSystem/commercialInsurance/paymentModule/commercialInsuranceReal.vue'),meta:['商保管理','商保支付']},//
      {path: 'commercialInsuranceRealCW',           name: 'commercialInsuranceRealCW',           component:()=>import('../views/staffSystem/commercialInsurance/paymentModule/commercialInsuranceRealCW.vue'),meta:['商保管理','商保支付审核']},//
      {path: 'commercialInsuranceFlow',             name: 'commercialInsuranceFlow',             component:()=>import('../views/staffSystem/commercialInsurance/paymentModule/commercialInsuranceFlow.vue'),meta:['商保管理','商保关闭审核']},//商保
      {path: 'commercialInsurancePurchaseRules',    name: 'commercialInsurancePurchaseRules',    component:()=>import('../views/staffSystem/commercialInsurance/commercialInsurancePurchaseRules/commercialInsurancePurchaseRules.vue'),meta:['商保管理','商保投保规则维护']},//商保投保规则维护
      {path: 'findstaffoverall',                    name: 'findstaffoverall',                    component:()=>import('../views/others/findStaffOverall/findstaffoverall.vue'),meta:['员工管理','员工信息查询']},
      {path: 'findstaffoverallDetial',              name: 'findstaffoverallDetial',              component:()=>import('../views/others/findStaffOverall/findstaffoverallDetial.vue')},
      {path: 'newsreview',                          name: 'newsreview',                          component:()=>import('../views/staffSystem/staffNewsModule/newsreview/newsreview.vue'),meta:['通知管理','员工消息']},
      {path: 'newfile',                             name: 'newfile',                             component:()=>import('../views/staffSystem/informmanage/addinform/newfile.vue')},//新建文件

      {path: 'fddContract',                         name: 'fddContract',                         component:()=>import('../views/staffSystem/staffContractModule/fddContract/fddContract.vue'),meta:['劳动合同信息','电子合同信息']},//电子合同
      {path: 'staffcontractinfo',                   name: 'staffcontractinfo',                   component:()=>import('../views/staffSystem/staffContractModule/staffContract/staffcontract.vue'),meta:['劳动合同信息','所有劳动合同信息']},//合同信息2 20190226
         {path: 'businessinsuranceinformation',     name: 'businessinsuranceinformation',        component:()=>import('../views/staffSystem/BusinessInsuranceManage/BusinessInsuranceInformation.vue'),meta:['商保管理','商保信息查询']},//商保信息
      {path: 'IncreaseOrDecreaseStaff',             name: 'IncreaseOrDecreaseStaff',             component:()=>import('../views/staffSystem/increaseDecreaseStaff/IncreaseOrDecreaseStaff .vue')},//增减员工
      {path: 'clientlist',                          name: 'clientlist',                          component:()=>import('../views/staffSystem/increaseDecreaseStaff/clientlisttoywy.vue')},//客户名单
      {path: 'clientlisttosth',                     name: 'clientlisttosth',                     component:()=>import('../views/staffSystem/increaseDecreaseStaff/clientlisttosth.vue')},//针对胜通和本部的客户名单
      {path: 'financialFundAndInsurance',           name: 'financialFundAndInsurance',           component:()=>import('../views/staffSystem/staffWageManageModule/financialFundAndInsurance/financialFundAndInsurance.vue'),meta:['社保公积金','社保公积金预算表数据维护']},//财务社保公积金
      {path: 'financialFundAndInsuranceCW',         name: 'financialFundAndInsuranceCW',         component:()=>import('../views/staffSystem/staffWageManageModule/financialFundAndInsurance/financialFundAndInsuranceCW.vue'),meta:['社保公积金','社保公积金预算表审核']},//财务社保公积金
      {path: 'financialFundAndInsuranceYWY',        name: 'financialFundAndInsuranceYWY',        component:()=>import('../views/staffSystem/staffWageManageModule/financialFundAndInsurance/financialFundAndInsuranceYWY.vue'),meta:['社保公积金','社保公积金预算表-业务员']},//财务社保公积金
      {path: 'financialFundAndInsuranceReal',       name: 'financialFundAndInsuranceReal',       component:()=>import('../views/staffSystem/staffWageManageModule/financialFundAndInsuranceReal/financialFundAndInsuranceReal.vue'),meta:['社保公积金','社保公积金明细表数据维护']},//财务社保公积金
      {path: 'financialFundAndInsuranceRealCW',     name: 'financialFundAndInsuranceRealCW',     component:()=>import('../views/staffSystem/staffWageManageModule/financialFundAndInsuranceReal/financialFundAndInsuranceRealCW.vue'),meta:['社保公积金','社保公积金明细表审核']},//财务社保公积金
      {path: 'socialFundCertificate',               name: 'socialFundCertificate',           component:()=>import('../views/staffSystem/staffWageManageModule/socialFundCertificate/socialFundCertificate.vue'),meta:['社保公积金','社保公积金证明查询和维护']},//社保公积金证明查询和维护
      {path: 'certificatemange',                    name: 'certificatemange',                    component:()=>import('../views/staffSystem/certifymanage/certificate/certificatemange.vue'),meta:['在线证明','在线证明处理记录']},//证明管理
      {path: 'staffCertifyNew',                     name: 'staffCertifyNew',                     component:()=>import('../views/staffSystem/staffManageModule/staffCertify/staffCertifyNew.vue'),meta:['在线证明','在线证明申请维护']},//业务员证明审核
      {path: 'dimissionCertify',                    name: 'dimissionCertify',                    component:()=>import('../views/staffSystem/staffManageModule/staffDimission/dimissionCertify.vue'),meta:['员工离职','在线离职申请审核']},//业务员证明审核
      {path: 'staffdimission',                      name: 'staffdimission',                      component:()=>import('../views/staffSystem/staffManageModule/staffDimission/staffDimission.vue'),meta:['员工离职','员工离职记录']}, //员工离职2
      {path: 'siAfIndexPage',                       name: 'siAfIndexPage',                       component:()=>import('../views/staffSystem/ProvidentFundManagement/indexPage/siAfIndexPage.vue'),meta:['社保公积金','业务员数据统计']},//社保包配置
      {
        path: 'siAfIndexPageZY',
        name: 'siAfIndexPageZY',
        component: () => import('../views/staffSystem/ProvidentFundManagement/indexPage/siAfIndexPageZY.vue'),
        meta: ['社保公积金', '专员数据统计']
      },//社保包配置
      {
        path: 'socialInsurance',
        name: 'socialInsurance',
        component: () => import('../views/staffSystem/ProvidentFundManagement/socialInsurance/socialInsurance.vue'),
        meta: ['社保公积金基础维护', '社保包配置']
      },//社保包配置
      {
        path: 'accumulationFund',
        name: 'accumulationFund',
        component: () => import('../views/staffSystem/ProvidentFundManagement/accumulationFund/accumulationFund.vue'),
        meta: ['社保公积金基础维护', '公积金配置']
      },//公积金配置
      {
        path: 'socialInsuranceDetail',
        name: 'socialInsuranceDetail',
        component: () => import('../views/staffSystem/ProvidentFundManagement/socialInsuranceDetail/socialInsurance.vue'),
        meta: ['社保公积金基础维护', '社保包配置']
      },//社保包配置
      {
        path: 'accumulationFundDetail',
        name: 'accumulationFundDetail',
        component: () => import('../views/staffSystem/ProvidentFundManagement/accumulationFundDetail/accumulationFund.vue'),
        meta: ['社保公积金基础维护', '公积金配置']
      },//公积金配置
      {
        path: 'paynotification',
        name: 'paynotification',
        component: () => import('../views/staffSystem/ProvidentFundManagement/payNotification.vue')
      },//缴纳提示
      {
        path: 'AllStaffDetailData',
        name: 'AllStaffDetailData',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/AllStaffDetailData.vue')
      },//导出全量明细表数据
      {
        path: 'customerManageStaff',
        name: 'customerManageStaff',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/customerManage/customerManageStaff.vue'),
        meta: ['社保公积金', '增减员-业务员']
      },//客户方
      {
        path: 'clientlisttosthNew',
        name: 'clientlisttosthNew',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/clientlisttosthNew.vue'),
        meta: ['社保公积金', '增减员-专员']
      },//针对胜通和本部的客户名单
      {
        path: 'increaseDecreaseStaffSupplier',
        name: 'increaseDecreaseStaffSupplier',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/increaseDecreaseStaffSupplier.vue'),
        meta: ['社保公积金', '增减员-第三方']
      },//针对第三方的
      {
        path: 'socialSecurityAndProvidentFundAbnormalData',
        name: 'socialSecurityAndProvidentFundAbnormalData',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/socialSecurityAndProvidentFundAbnormalData.vue'),
        meta: ['社保公积金', '社保公积金异常历史数据-本部']
      },
      {
        path: 'socialSecurityAndProvidentFundAbnormalDataSupplier',
        name: 'socialSecurityAndProvidentFundAbnormalDataSupplier',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/socialSecurityAndProvidentFundAbnormalDataSupplier.vue'),
        meta: ['社保公积金', '社保公积金异常历史数据-第三方']
      },
      {
        path: 'noStopStaffSocialInsuranceInformation',
        name: 'noStopStaffSocialInsuranceInformation',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/noStopStaffSocialInsuranceInformation.vue'),
        meta: ['社保公积金', '已下岗未停社保']
      },
      {
        path: 'noStopStaffAccumulationFundInformation',
        name: 'noStopStaffAccumulationFundInformation',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/noStopStaffAccumulationFundInformation.vue'),
        meta: ['社保公积金', '已下岗未停公积金']
      },
      {
        path: 'staffEntryDimission',
        name: 'staffEntryDimission',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/staffEntryDimission/staffEntryDimission.vue'),
        meta: ['上下岗管理', '员工上下岗']
      },//增减员工2
      {
        path: 'staffEntry',
        name: 'staffEntry',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/staffEntryDimission/staffEntry.vue'),
        meta: ['上下岗管理', '员工入离职审核']
      },//增减员工2
      {
        path: 'staffICDCHistory',
        name: 'staffICDCHistory',
          component: () => import('../views/staffSystem/increaseDecreaseStaff2/staffICDCHistory/staffICDCHistory.vue'),
          meta: ['社保公积金', '历史记录']
      },//增减员工2
        {
            path: 'icdcRuleSearch',
          name: 'icdcRuleSearch',
          component: () => import('../views/staffSystem/increaseDecreaseStaff2/icdcRule/icdcRuleSearch.vue'),
          meta: ['社保公积金', '社保公积金操作规则']
        },//增减员工2
      {
        path: 'increaseStaffSettings',
        name: 'increaseStaffSettings',
        component: () => import('../views/staffSystem/increaseStaffSettings/increaseStaffSettings.vue'),
        meta: ['社保公积金', '社保公积金增员必填信息']
      },//增减员工2
      {
        path: 'staffSocialSecurityProof',
        name: 'staffSocialSecurityProof',
        component: () => import('../views/staffSystem/StaffSocialSecurityProof/staffSocialSecurityProof.vue'),
        meta: ['社保公积金', '参保证明人员信息']
      },
      {
        path: 'staffSocialSecurityProofWhiteList',
        name: 'staffSocialSecurityProofWhiteList',
        component: () => import('../views/staffSystem/StaffSocialSecurityProof/staffSocialSecurityProofWhiteList.vue'),
        meta: ['社保公积金', '参保证明人员白名单']
      },
      {
        path: 'paymentVoucherSpecialist',
        name: 'paymentVoucherSpecialist',
        component: () => import('../views/staffSystem/paymentVoucherManagement/paymentVoucherSpecialist.vue'),
        meta: ['社保公积金', '专员上传缴费凭证']
      },
      {
        path: 'paymentVoucherLockData',
        name: 'paymentVoucherLockData',
        component: () => import('../views/staffSystem/paymentVoucherManagement/paymentVoucherLockData.vue'),
        meta: ['社保公积金', '室经理锁定数据']
      },
      {
        path: 'paymentVoucherSettings',
        name: 'paymentVoucherSettings',
        component: () => import('../views/staffSystem/paymentVoucherManagement/paymentVoucherSettings/paymentVoucherSettings.vue'),
        meta: ['社保公积金', '缴费提醒配置']
      },
      {
        path: 'staffTransfer',
        name: 'staffTransfer',
        component: () => import('../views/staffSystem/staffManageModule/staffTransfer/staffTransfer.vue'),
        meta: ['上下岗管理', '员工调动']
      },//员工调动
      {
        path: 'staffContractTODO',
        name: 'staffContractTODO',
        component: () => import('../views/staffSystem/staffContractModule/staffContractTODO/staffContractTODO.vue'),
        meta: ['劳动关系', '劳动合同待办']
      },//劳动合同代办
      {
        path: 'staffContractNoSignature',
        name: 'staffContractNoSignature',
        component: () => import('../views/staffSystem/staffContractModule/staffContractTODO/staffContractNoSignature/staffContractNoSignature.vue'),
        meta: ['劳动关系', '劳动合同待办信息']
      },//电子合同应签未签（员工）
      {
        path: 'staffContractNotExist',
        name: 'staffContractNotExist',
        component: () => import('../views/staffSystem/staffContractModule/staffContractTODO/staffContractNotExist/staffContractNotExist.vue'),
        meta: ['劳动关系', '劳动合同待办信息']
      },//暂无合同
      {
        path: 'staffContractExpired',
          name: 'staffContractExpired',
          component: () => import('../views/staffSystem/staffContractModule/staffContractTODO/staffContractExpired/staffContractExpired.vue'),
          meta: ['劳动关系', '劳动合同待办信息']
      },//过期合同
        {
            path: 'staffContractTODOManagement',
            name: 'staffContractTODOManagement',
            component: () => import('../views/staffSystem/staffContractModule/staffContractTODO/staffContractTODOManagement/staffContractTODOManagement.vue'),
            meta: ['劳动关系', '劳动合同待办信息']
        },
        {
            path: 'staffNoFullTimeContractExpiredTODO',
            name: 'staffNoFullTimeContractExpiredTODO',
            component: () => import('../views/staffSystem/staffContractModule/staffContractTODO/staffNoFullTimeContractExpired/staffNoFullTimeContractExpiredTODO.vue'),
            meta: ['劳动关系', '合同过期待办']
        },
        {
            path: 'payWageTime',
            name: 'payWageTime',
            component: () => import('../views/financeSystem/payWageTime/payWageTime.vue'),
            meta: ['薪酬管理', '客户工资发放时间']
        },//工资支付时间
        {
            path: 'taxComputeSetting',
            name: 'taxComputeSetting',
            component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxComputeSetting.vue'),
        meta: ['薪酬管理', '工资计算配置']
      },//工资计算配置
      {
        path: 'taxWageMatch',
        name: 'taxWageMatch',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxWageMatch.vue'),
        meta: ['薪酬管理', '工资数据匹配']
      },//工资计算配置
      {path: 'customerFirstWage',                   name: 'customerFirstWage',                   component:()=>import('../views/staffSystem/staffWageManageModule/customerFirstWage/customerFirstWage.vue'),meta:['薪酬管理','员工结算初表']},//个税计算taxComputeSummary
      {path: 'taxCompute', name: 'taxCompute', component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxCompute.vue'), meta: ['薪酬管理', '工资发放'] },//个税计算taxComputeSummary
      {path: 'wageDishManage', name: 'wageDishManage', component: () => import('../views/staffSystem/staffWageManageModule/wageDishManage/wageDishManage.vue'), meta: ['薪酬管理', '工资盘管理'] },//工资盘管理
      {path: 'wageDishAudit',                       name: 'wageDishAudit',                       component:()=>import('../views/staffSystem/staffWageManageModule/wageDishAudit/wageDishAudit.vue'),meta:['薪酬管理','工资盘审核-业务']},//工资盘审核
      {path: 'wageDishAuditITManage',               name: 'wageDishAuditITManage',               component:()=>import('../views/staffSystem/staffWageManageModule/wageDishAudit/wageDishAuditITManage.vue'),meta:['薪酬管理','工资盘IT管理']},//工资盘IT管理
      {path: 'wageDishAuditByOrgination',           name: 'wageDishAuditByOrgination',           component:()=>import('../views/staffSystem/staffWageManageModule/wageDishAudit/wageDishAuditByOrgination.vue'),meta:['薪酬管理','工资盘审核-业务（初审）']},//工资盘审核
      {
        path: 'wageDishSerial',
        name: 'wageDishSerial',
        component: () => import('../views/staffSystem/staffWageManageModule/wageDishSerial/wageDishSerial.vue'),
        meta: ['薪酬管理', '工资盘审核-财务']
      },//工资盘流水
      {
        path: 'wageDishFeedbackYW',
        name: 'wageDishFeedbackYW',
        component: () => import('../views/staffSystem/staffWageManageModule/wageDishFeedback/wageDishFeedbackYW.vue'),
        meta: ['薪酬管理', '工资发放错误待办记录']
      },//工资发放错误待办记录
      // {
      //   path: 'specialDeduction',
      //   name: 'specialDeduction',
      //   component: () => import('../views/staffSystem/staffWageManageModule/specialDeduction/specialDeduction.vue'),
      //   meta: ['薪酬管理', '专项扣除管理']
      // },
      // {
      //   path: 'specialDeductionYWY',
      //   name: 'specialDeductionYWY',
      //   component: () => import('../views/staffSystem/staffWageManageModule/specialDeduction/specialDeductionYWY.vue'),
      //   meta: ['薪酬管理', '专项扣除查询']
      // },//专项扣除计算 业务员 只读
            {
        path: 'specialDeduction',
        name: 'specialDeduction',
        component: () => import('../views/staffSystem/staffWageManageModule/specialDeduction/specialDeductionNew.vue'),
        meta: ['薪酬管理', '专项扣除管理']
      },
      {
        path: 'specialDeductionYWY',
        name: 'specialDeductionYWY',
        component: () => import('../views/staffSystem/staffWageManageModule/specialDeduction/specialDeductionYWYNew.vue'),
        meta: ['薪酬管理', '专项扣除查询']
      },//专项扣除计算 业务员 只读
      {
        path: 'taxManage',
        name: 'taxManage',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxManage.vue'),
        meta: ['薪酬管理', '个税管理（财务）']
      },//个税管理
      {
        path: 'taxManageShangHai',
        name: 'taxManageShangHai',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxManageShangHai.vue'),
        meta: ['薪酬管理', '个税管理（上海）']
      },//个税管理
      {
        path: 'taxManageChongQing',
        name: 'taxManageChongQing',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxManageChongQing.vue'),
        meta: ['薪酬管理', '个税管理（重庆）']
      },//个税管理
      {
        path: 'taxManageGuangZhou',
        name: 'taxManageGuangZhou',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxManageGuangZhou.vue'),
        meta: ['薪酬管理', '个税管理（广州）']
      },//个税管理
      {
        path: 'taxManageFoShan',
        name: 'taxManageFoShan',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxManageFoShan.vue'),
        meta: ['薪酬管理', '个税管理（佛山）']
      },//个税管理
      {
        path: 'taxManageNanHai',
        name: 'taxManageNanHai',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxManageNanHai.vue'),
        meta: ['薪酬管理', '个税管理（南海）']
      },//个税管理
      {
        path: 'taxManageBusiness',
        name: 'taxManageBusiness',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxManageBusiness.vue'),
        meta: ['薪酬管理', '个税管理（业务）']
      },//个税管理(业务)
      {
        path: 'taxOfficial',
        name: 'taxOfficial',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxOfficial.vue'),
        meta: ['薪酬管理', '个税管理（税局）']
      },//个税管理(税局)
      {
        path: 'taxManageShengTongJian',
        name: 'taxManageShengTongJian',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxManageShengTongJian.vue'),
        meta: ['薪酬管理', '个税管理（胜通建）']
      },//个税管理
      {
        path: 'taxDifference',
        name: 'taxDifference',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxDifference.vue'),
        meta: ['薪酬管理', '个税差异表']
      },//个税差异表
      {
        path: 'taxFreeAudit',
        name: 'taxFreeAudit',
        component: () => import('../views/staffSystem/staffWageManageModule/taxFreeAudit/taxFreeAudit.vue'),
        meta: ['薪酬管理', '免税收入审核']
      },//免税收入审核
      {
        path: 'findFinancialStaffAverageWage',
        name: 'findFinancialStaffAverageWage',
        component: () => import('../views/staffSystem/staffWageManageModule/financialStaffAverageWage/financialStaffAverageWage.vue'),
        meta: ['薪酬管理', '平均工资']
      },//平均实发工资
      {
        path: 'checkwagespage',
        name: 'checkwagespage',
        component: () => import('../views/staffSystem/staffWageManageModule/checkWage/checkwages.vue'),
        meta: ['薪酬管理', '工资条信息']
      },//工资信息
      {
        path: 'financialWageDetail',
        name: 'financialWageDetail',
        component: () => import('../views/financeSystem/financialWageDetail/financialWageDetail.vue'),
        meta: ['薪酬管理', '工资明细表']
      },//工资明细表
      {
        path: 'wageDishSerialSummaryTable',
        name: 'wageDishSerialSummaryTable',
        component: () => import('../views/staffSystem/staffWageManageModule/wageDishSerial/wageDishSerialSummaryTable.vue'),
        meta: ['薪酬管理', '项目工资汇总表（财务）']
      },//工资盘流水
      {
        path: 'sysAreaBank',
        name: 'sysAreaBank',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/sysAreaBank/sysAreaBank.vue')
      },//社保地区银行
      {
        path: 'operationData',
        name: 'operationData',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/sysAreaBank/operationData.vue')
      },//社保地区银行
      {
        path: 'sysAreaUser',
        name: 'sysAreaUser',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/sysAreaUser/sysAreaUser.vue')
      },//社保地区负责人
      {
        path: 'operationData',
        name: 'operationData',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/sysAreaUser/operationData.vue')
      },//社保地区负责人
      {
        path: 'sysPayBank',
        name: 'sysPayBank',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/sysPayBank/sysPayBank.vue')
      },//付款方银行
      {
        path: 'operationData',
        name: 'operationData',
        component: () => import('../views/staffSystem/increaseDecreaseStaff2/sysPayBank/operationData.vue')
      },//付款方银行
      {path: 'validateNameTool',                    name: 'validateNameTool',                    component:()=>import('../views/staffSystem/increaseDecreaseStaff2/validateNameTool.vue'),meta: ['社保公积金','实用工具']},//导出全量明细表数据
      {path: 'areaBankManageList',                  name: 'areaBankManageList',                  component:()=>import('../views/staffSystem/ProvidentFundManagement/areaInfoManage/areaBankManageList.vue'), meta:['地区数据基础维护','地区银行信息']},//地区银行
      {path: 'supplierBankManageList',              name: 'supplierBankManageList',              component:()=>import('../views/staffSystem/ProvidentFundManagement/areaInfoManage/supplierBankManageList.vue'), meta:['地区数据基础维护','供应商银行信息']},//供应商银行
      {path: 'sysCertifyFddTemplate',               name: 'sysCertifyFddTemplate',               component:()=>import('../views/staffSystem/staffOnlineApplyModule/sysCertifyFddTemplate/sysCertifyFddTemplate.vue'),meta:['员工离职','证明模板管理']},//电子证明模板管理
      {path: 'accmulationFund',                     name: 'accmulationFund',                     component:()=>import('../views/staffSystem/ProvidentFundManagement/statisticsInterface/accumulationFund.vue'), meta:['社保公积金','公积金在缴帐查询']},//公积金在缴帐查询
      {path: 'staffInsurance',                      name: 'staffInsurance',                      component:()=>import('../views/staffSystem/ProvidentFundManagement/statisticsInterface/staffInsurance.vue'), meta:['社保公积金','社保在缴帐查询']},//社保在缴帐查询
      {path: 'staffInterfaceSettle',                name: 'staffInterfaceSettle',                component:()=>import('../views/staffSystem/ProvidentFundManagement/statisticsInterface/staffInterfaceSettle.vue'),meta: ['社保公积金','结算查询']},//社保在缴帐查询
      {path: 'staffInsuranceNoPay',                 name: 'staffInsuranceNoPay',                 component:()=>import('../views/staffSystem/ProvidentFundManagement/statisticsInterface/staffInsuranceNoPay.vue')},//社保在缴帐查询
      {path: 'physicalExaminationProjectManage',    name: 'physicalExaminationProjectManage',    component:()=>import('../views/staffSystem/physicalExaminationManage/physicalExaminationProjectManage/physicalExaminationProjectManage.vue'),meta:['体检管理','体检项目管理']},//体检项目管理
      {path: 'registeredPartyMember',               name: 'registeredPartyMember',               component:()=>import('../views/staffSystem/staffPartyMemberManage/registeredPartyMember/registeredPartyMember.vue'),meta:['党员管理','在册党员信息']},//在册党员
      {path: 'registeredPartyMemberManage',         name: 'registeredPartyMemberManage',         component:()=>import('../views/staffSystem/staffPartyMemberManage/registeredPartyMember/registeredPartyMemberManage.vue'),meta:['党员管理','在册党员信息管理']},//在册党员
      {path: 'transferredPartyMember',              name: 'transferredPartyMember',              component:()=>import('../views/staffSystem/staffPartyMemberManage/transferredPartyMember/transferredPartyMember.vue'),meta:['党员管理','转出党员信息']},//转出党员
      {path: 'transferredPartyMemberManage',        name: 'transferredPartyMemberManage',        component:()=>import('../views/staffSystem/staffPartyMemberManage/transferredPartyMember/transferredPartyMemberManage.vue'),meta:['党员管理','转出党员信息管理']},//转出党员
      {path: 'registeredPersonnelFileManage',       name: 'registeredPersonnelFileManage',       component:()=>import('../views/staffSystem/staffPersonnelFileManage/registeredPersonnelFile/registeredPersonnelFileManage.vue'),meta:['人事档案管理','在库人事档案台账管理']},//在库人事档案台账管理
      {path: 'registeredPersonnelFile',             name: 'registeredPersonnelFile',             component:()=>import('../views/staffSystem/staffPersonnelFileManage/registeredPersonnelFile/registeredPersonnelFile.vue'),meta:['人事档案管理','在库人事档案台账']},//在库人事档案台账
      {path: 'transferredPersonnelFileManage',      name: 'transferredPersonnelFileManage',      component:()=>import('../views/staffSystem/staffPersonnelFileManage/transferredPersonnelFile/transferredPersonnelFileManage.vue'),meta:['人事档案管理','转出人事档案台账管理']},//转出人事档案台账管理
      {path: 'transferredPersonnelFile',            name: 'transferredPersonnelFile',            component:()=>import('../views/staffSystem/staffPersonnelFileManage/transferredPersonnelFile/transferredPersonnelFile.vue'),meta:['人事档案管理','转出人事档案台账']},//转出人事档案台账

      {path: 'staffPersonnelFileConsultManage',     name: 'staffPersonnelFileConsultManage',     component:()=>import('../views/staffSystem/staffPersonnelFileManage/staffPersonnelFileConsult/staffPersonnelFileConsultManage.vue'),meta:['人事档案管理','查借阅、复印、摘抄记录管理']},//查借阅、复印、摘抄记录管理

      {path: 'staffPersonnelFileBulkMaterialManage',name: 'staffPersonnelFileBulkMaterialManage',component:()=>import('../views/staffSystem/staffPersonnelFileManage/staffPersonnelFileBulkMaterial/staffPersonnelFileBulkMaterialManage.vue'),meta:['人事档案管理','散材料移交登记台账管理']},//散材料移交登记台账管理

      {path: 'financialStaffSettlementNew',         name: 'financialStaffSettlementNew',         component:()=>import('../views/staffSystem/staffWageManageModule/financialStaffSettlement/financialStaffSettlementNew.vue'),meta:['薪酬管理','结算数据维护']},//结算数据维护
      {path: 'wagesNoPay',                          name: 'wagesNoPay',                          component:()=>import('../views/staffSystem/staffDataMonitor/wagesNoPay/wagesNoPay.vue'),meta:['薪酬管理','工资异常']},//工资异常
      {path: 'staffFundAndInsuranceTODOManagement', name: 'staffFundAndInsuranceTODOManagement', component:()=>import('../views/staffSystem/staffDataMonitor/staffFundAndInsurance/staffFundAndInsuranceTODOManagement/staffFundAndInsuranceTODOManagement.vue'),meta:['社保公积金','社保公积金异常']},
      {path: 'staffFundAndInsuranceNoPay',          name: 'staffFundAndInsuranceNoPay',          component:()=>import('../views/staffSystem/staffDataMonitor/staffFundAndInsurance/staffFundAndInsuranceNoPay/staffFundAndInsuranceNoPay.vue'),meta:['社保公积金','无社保']},
      {path: 'staffFundAndInsuranceNoActualPayment',name: 'staffFundAndInsuranceNoActualPayment',component:()=>import('../views/staffSystem/staffDataMonitor/staffFundAndInsurance/staffFundAndInsuranceNoActualPayment/staffFundAndInsuranceNoActualPayment.vue'),meta:['社保公积金','有实缴无预算']},
      {path: 'staffFundAndInsuranceNoBudget',       name: 'staffFundAndInsuranceNoBudget',       component:()=>import('../views/staffSystem/staffDataMonitor/staffFundAndInsurance/staffFundAndInsuranceNoBudget/staffFundAndInsuranceNoBudget.vue'),meta:['社保公积金','有预算无实缴']},
      {path: 'staffFullTimeContractTODOManagement', name: 'staffFullTimeContractTODOManagement', component:()=>import('../views/staffSystem/staffDataMonitor/staffContract/staffFullTimeContractTODOManagement/staffFullTimeContractTODOManagement.vue'),meta:['劳动关系','全日制劳动合同异常']},
      {path: 'staffFullTimeContractNotExist',       name: 'staffFullTimeContractNotExist',       component:()=>import('../views/staffSystem/staffDataMonitor/staffContract/staffFullTimeContractNotExist/staffFullTimeContractNotExist.vue'),meta:['全日制劳动合同待办','劳动合同超30天没签']},//待签合同
      {path: 'staffFullTimeContractExpired',        name: 'staffFullTimeContractExpired',        component:()=>import('../views/staffSystem/staffDataMonitor/staffContract/staffFullTimeContractExpired/staffFullTimeContractExpired.vue'),meta:['全日制劳动合同待办','劳动合同过期30天']},//合同过期30天
      {path: 'staffFullTimeContractNoSignature',    name: 'staffFullTimeContractNoSignature',    component:()=>import('../views/staffSystem/staffContractModule/staffContractTODO/staffFullTimeContractWillExpire/staffFullTimeContractWillExpire.vue'),meta:['全日制劳动合同待办','劳动合同30天内到期']},//合同30天内到期
      {path: 'commercialInsuranceNoPay',            name: 'commercialInsuranceNoPay',            component:()=>import('../views/staffSystem/staffDataMonitor/commercialInsuranceNoPay/commercialInsuranceNoPay.vue'),meta:['商保管理','商保异常']},//商保异常

      {path: 'customerDeliveryPersonnel',           name: 'customerDeliveryPersonnel',           component:()=>import('../views/customerSystem/customerDeliveryPersonnel/customerDeliveryPersonnel.vue'),meta:['客户交付人员审批表','客户交付人员审批表']},//客户交付人员审批表
      {path: 'customerWageDetails',                 name: 'customerWageDetails',                 component:()=>import('../views/customerSystem/customerWageDetails/customerWageDetails.vue'),meta:['客户员工发放明细表','客户员工发放明细表']},//客户员工发放明细表
      {path: 'financialSettlementStaffDetail',      name: 'financialSettlementStaffDetail',      component:()=>import('../views/customerSystem/financialSettlementStaffDetail/financialSettlementStaffDetail.vue'),meta:['客户员工结算明细表','客户员工结算明细表']},//客户员工结算明细表

      {path: 'staffProfessionalTitleManage',        name: 'staffProfessionalTitleManage',        component:()=>import('../views/staffSystem/staffProfessionalTitleModule/staffProfessionalTitleManage.vue'),meta:['员工信息','职称/证书证件管理']},
      {path: 'staffInfoEducationExperienceManage',  name: 'staffInfoEducationExperienceManage',  component:()=>import('../views/staffSystem/staffInfoEducationExperienceModule/staffInfoEducationExperienceManage.vue'),meta:['员工信息','教育经历证件管理']},

      {path: 'financialStaffSettlementNew2',        name: 'financialStaffSettlementNew2',        component:()=>import('../views/staffSystem/staffWageManageModule/financialSettlement/financialSettlementNewTest.vue'),meta:['结算管理','结算数据维护']},//结算数据维护
      {path: 'financialSettlementNewITManage',        name: 'financialSettlementNewITManage',        component:()=>import('../views/staffSystem/staffWageManageModule/financialSettlement/financialSettlementNewITManage.vue'),meta:['结算管理','结算数据维护IT管理']},//结算数据维护

      {path: 'staffContractManage',                 name: 'staffContractManage',                 component:()=>import('../views/staffSystem/staffContractModule/staffContractManage/staffContractManage.vue'),meta:['劳动关系','劳动合同信息']},
      //{path: 'nonFddContract',                      name: 'nonFddContract',                      component:()=>import('../views/staffSystem/staffContractModule/nonFddContract/nonFddContract.vue'),meta:['劳动合同信息','非电子劳动合同']},
      {
        path: 'staffRecommendation',
        name: 'staffRecommendation',
        component: () => import('../views/staffSystem/staffRecommendation/staffRecommendation.vue'),
        meta: ['员工信息', '投诉建议']
      },//投诉建议
      {
        path: 'commercialInsuranceContracts',
        name: 'commercialInsuranceContracts',
        component: () => import('../views/staffSystem/commercialInsurance/commercialInsuranceContracts/commercialInsuranceContracts.vue'),
        meta: ['商保管理', '商保维护-客户指定']
      },//投诉建议
      {
        path: 'commercialInsuranceTransfer',
        name: 'commercialInsuranceTransfer',
        component: () => import('../views/staffSystem/commercialInsurance/commercialInsuranceTransfer/commercialInsuranceTransfer.vue'),
        meta: ['商保管理', '商保调动审核']
      },//员工金蝶调动
      {
        path: 'staffOriginalBudgetFile',
        name: 'staffOriginalBudgetFile',
        component: () => import('../views/staffSystem/staffWageManageModule/financialFundAndInsurance/staffOriginalBudgetFile.vue'),
        meta: ['社保公积金', '预算表']
      },

       {
        path: 'sysDataPTSSynchronizationGroup',
        name: 'sysDataPTSSynchronizationGroup',
        component: () => import('../views/financeSystem/sysDataPTSSynchronization/sysDataPTSSynchronizationGroup.vue'),
        meta: ['薪酬管理', 'PTS对接管理','PTS对接']
      },//PTS对接管理
      {
        path: 'sysDataPTSSynchronizationGroupMonitor',
        name: 'sysDataPTSSynchronizationGroupMonitor',
        component: () => import('../views/financeSystem/sysDataPTSSynchronization/sysDataPTSSynchronizationGroupMonitor.vue'),
        meta: ['薪酬管理', 'PTS对接管理','PTS监控']
      },//PTS对接管理
      {
        path: 'financialPersonalTaxExcludeManagement',
        name: 'financialPersonalTaxExcludeManagement',
        component: () => import('../views/financeSystem/financialPersonalTaxExcludeManage/financialPersonalTaxExcludeManagement.vue'),
        meta: ['薪酬管理', 'PTS对接管理', '发工资不报个税']
      },
      {
        path: 'staffOverseasManagement',
        name: 'staffOverseasManagement',
        component: () => import('../views/staffSystem/staffOverseasManage/staffOverseasManagement.vue'),
        meta: ['薪酬管理', 'PTS对接管理', '境外人员管理']
      },
      {path: 'supplierReimburseGroupList',            name: 'supplierReimburseGroupList',            component:()=>import('../views/staffSystem/supplierReimburse/supplierReimburseGroupList.vue'),meta:['薪酬管理','供应商报销管理']},
    ]
  },


  {//中台支撑系统
    path: '/mainPlatformSupportSystem',        name: 'mainPlatformSupportSystem',      component:()=>import('../components/stonghrSysMenu/mainPlatformSupportSystem.vue'),
    children: [
      {path: 'welcome', name: 'welcome', component: () => import('../views/others/welcome/welcome.vue')},
      {
        path: 'programming2',
        name: 'programming2',
        component: () => import('../views/others/programming/programming.vue')
      },
      {
        path: 'fddContracts',
        name: 'fddContracts',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/fddContracts/fddContracts.vue'),
        meta: ['电子合同管理', '电子合同信息']
      },//电子合同信息
      {
        path: 'fddContractsManage',
        name: 'fddContractsManage',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/fddContracts/fddContractsManage.vue'),
        meta: ['电子合同管理', '电子合同信息维护']
      },//电子合同信息维护
      {
        path: 'fddContractsOldChapter',
        name: 'fddContractsOldChapter',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/fddContracts/fddContractsOldChapter.vue'),
        meta: ['电子合同管理', '电子合同信息维护-旧章']
      },//电子合同信息维护
      {
        path: 'fddAgreement',
        name: 'fddAgreement',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/fddAgreement/fddAgreement.vue'),
        meta: ['电子合同管理', '电子协议维护']
      },
      {
        path: 'fddDimissionCertify',
        name: 'fddDimissionCertify',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/fddDimissionCertify/fddDimissionCertify.vue'),
        meta: ['电子合同管理', '电子离职证明维护']
      },

      {
        path: 'sysContractsFddTemplate',
        name: 'sysContractsFddTemplate',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/sysContractsFddTemplate/sysContractsFddTemplate.vue'),
        meta: ['电子合同管理', '电子合同模板维护']
      },//电子合同模板管理
      {
        path: 'fddContractCompany',
        name: 'fddContractCompany',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/fddContractCompany/fddContractCompany.vue'),
        meta: ['电子合同管理', '电子印章维护']
      }, //2019.03.25
      {
        path: 'sysContractsFddTemplateAudit',
        name: 'sysContractsFddTemplateAudit',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/sysContractsFddTemplate/sysContractsFddTemplateAudit.vue'),
        meta: ['电子合同管理', '合同模板测试审核']
      }, //合同模板测试审核
      {
        path: 'staffContractLetter',
        name: 'staffContractLetter',
        component: () => import('../views/staffSystem/staffContractModule/staffContractLetter/staffContractLetter.vue'),
        meta: ['电子合同管理', '续签劳动合同意向书维护']
      }, //意向书维护页面
      {
        path: 'companyOrganizationInformation',
        name: 'companyOrganizationInformation',
        component: () => import('../views/staffSystem/staffContractModule/companyOrganizationInformation/companyOrganizationInformation.vue'),
        meta: ['电子合同管理', '胜通和机构信息']
      }, //胜通和机构
      {
        path: 'customerInfoTest',
        name: 'customerInfoTest',
        component: () => import('../views/customerSystem/customerManage/customerInfoTest/customerInfoTest.vue'),
        meta: ['客户管理', '客户资料维护']
      },//查看客户关联的业务员
      {
        path: 'customerInfoTestSec',
        name: 'customerInfoTestSec',
        component: () => import('../views/customerSystem/customerManage/customerInfoSec/customerInfoTest.vue'),
        meta: ['客户管理', '客户资料查看']
      },//查看客户关联的业务员
      {
        path: 'customerInfoAuditSC',
        name: 'customerInfoAuditSC',
        component: () => import('../views/customerSystem/customerManage/customerInfoAudit/customerInfoAuditSC/customerInfoAuditSC.vue'),
        meta: ['客户管理', '客户信息审核-市场部']
      },//客户信息审核-市场部
      {
        path: 'customerInfoAuditYW',
        name: 'customerInfoAuditYW',
        component: () => import('../views/customerSystem/customerManage/customerInfoAudit/customerInfoAuditYW/customerInfoAuditYW.vue'),
        meta: ['客户管理', '客户信息审核-业务部']
      },//客户信息审核-市场部
      {
        path: 'customerInfoAssign',
        name: 'customerInfoAssign',
        component: () => import('../views/customerSystem/customerManage/customerInfoAudit/customerInfoAssign/customerInfoAssign.vue'),
        meta: ['客户管理', '客户分配']
      },//客户分配
      {
        path: 'customerInfoSupplement',
        name: 'customerInfoSupplement',
        component: () => import('../views/customerSystem/customerManage/customerInfoAudit/customerInfoSupplement/customerInfoSupplement.vue'),
        meta: ['客户管理', '客户信息补充']
      },//客户分配
      {
        path: 'customerInfoView',
        name: 'customerInfoView',
        component: () => import('../views/customerSystem/customerManage/customerInfoTest/customerInfoView.vue'),
        meta: ['客户管理', '客户资料修改']
      },//查看客户关联的业务员
      {
        path: 'customerInfoHavePermission',
        name: 'customerInfoHavePermission',
        component: () => import('../views/customerSystem/customerManage/customerInfoHavePermission/customerInfoHavePermission.vue'),
        meta: ['客户管理', '客户资料查看（业务）']
      },//查看客户关联的业务员
      {
        path: 'customerInfoForSearch/:id',
        name: 'customerInfoForSearch',
        component: () => import('../views/customerSystem/customerManage/customerInfoForSearch/customerInfoForSearch.vue'),
        meta: ['客户管理', '客户信息详情']
      },//客户信息详情
      {
        path: 'customerVisitRecords',
        name: 'customerVisitRecords',
        component: () => import('../views/customerSystem/customerManage/customerVisitRecords/customerVisitRecords.vue'),
        meta: ['客户管理', '客户拜访管理']
      },//客户拜访管理
      {
        path: 'customerAuthorityChangeInfo',
        name: 'customerAuthorityChangeInfo',
        component: () => import('../views/customerSystem/customerManage/customerAuthorityChange/customerAuthorityChangeInfo.vue'),
        meta: ['客户管理', '客户权限变更']
      },//查看客户关联的业务员
      {
        path: 'customerInfoManagement',
        name: 'customerInfoManagement',
        component: () => import('../views/customerSystem/customerManage/customerManagement/customerInfoManagement.vue'),
        meta: ['客户管理', '客户资料IT管理']
      },//客户资料IT管理
      {
        path: 'customerCodeManagement',
        name: 'customerCodeManagement',
        component: () => import('../views/customerSystem/customerManage/customerCodeManage/customerCodeManagement.vue'),
        meta: ['客户管理', '通服客户编码管理']
      },//客户资料IT管理
      {
        path: 'supplierInfo',
        name: 'supplierInfo',
        component: () => import('../views/customerSystem/supplierManage/supplierInfo.vue'),
        meta: ['供应商管理', '供应商信息']
      },//供应商信息
      {
        path: 'supplierCharge',
        name: 'supplierCharge',
        component: () => import('../views/customerSystem/supplierManage/supplierCharge.vue'),
        meta: ['供应商管理', '供应商收费管理']
      },//供应商信息
        {
          path: 'welfareSupplierManagement',
          name: 'welfareSupplierManagement',
          component:()=>import('../views/staffSystem/welfareSupplierManage/welfareSupplierManagement.vue'),
          meta:['供应商管理','供应商信息维护-福利']
      },

      {
        path: 'frameworkContract',
        name: 'frameworkContract',
        component: () => import('../views/customerSystem/contractManage/incomeContractManage/frameworkContract/frameworkContract.vue'),
        meta: ['收入合同管理', '框架合同维护']
      },//合同管理-框架合同
      {
        path: 'frameworkContractTodoManagement',
        name: 'frameworkContractTodoManagement',
        component: () => import('../views/customerSystem/contractManage/incomeContractManage/frameworkContractTodo/frameworkContractTodoManagement.vue'),
        meta: ['收入合同管理', '框架合同签订待办']
      },//合同管理-框架合同签订待办
      {
        path: 'frameworkContractReview',
        name: 'frameworkContractReview',
        component: () => import('../views/customerSystem/contractManage/incomeContractManage/frameworkContract/frameworkContractReview.vue'),
        meta: ['收入合同管理', '框架合同审核']
      },//合同管理-框架合同
      {
        path: 'executionContract',
        name: 'executionContract',
        component: () => import('../views/customerSystem/contractManage/incomeContractManage/executionContract/executionContract.vue'),
        meta: ['收入合同管理', '执行合同']
      },//合同管理-执行合同
      {
        path: 'executionContractReadOnly',
        name: 'executionContractReadOnly',
        component: () => import('../views/customerSystem/contractManage/incomeContractManage/executionContract/executionContractReadOnly.vue'),
        meta: ['收入合同管理', '执行合同查询']
      },//合同管理-执行合同查询
      {
        path: 'frameworkContractReadOnly',
        name: 'frameworkContractReadOnly',
        component: () => import('../views/customerSystem/contractManage/incomeContractManage/frameworkContract/frameworkContractReadOnly.vue'),
        meta: ['收入合同管理', '框架合同查询']
      },//合同管理-框架合同查询
      {
        path: 'socialSecurityAgencyContract',
        name: 'socialSecurityAgencyContract',
        component: () => import('../views/customerSystem/contractManage/expenditureContractManage/socialSecurityAgency/socialSecurityAgencyContract.vue'),
        meta: ['支出合同管理', '社保代理合同']
      },//合同管理-社保代理合同
      {
        path: 'commercialInsuranceContract',
        name: 'commercialInsuranceContract',
        component: () => import('../views/customerSystem/contractManage/expenditureContractManage/commercialInsurance/commercialInsuranceContract.vue'),
        meta: ['支出合同管理', '商业险合同']
      },//合同管理-商业险合同
      {path: 'recruitmentTrainingContract',    name: 'recruitmentTrainingContract',    component:()=>import('../views/customerSystem/contractManage/expenditureContractManage/recruitmentTraining/recruitmentTrainingContract.vue'), meta:['支出合同管理','招聘培训合同']},//合同管理-招聘培训合同
      {path: 'platformSubcontract',            name: 'platformSubcontract',            component:()=>import('../views/customerSystem/contractManage/expenditureContractManage/platformSubcontract/platformSubcontract.vue'), meta:['支出合同管理','平台分包合同']},//合同管理-平台分包合同
      {path: 'welfarePurchaseContract',        name: 'welfarePurchaseContract',        component:()=>import('../views/customerSystem/contractManage/expenditureContractManage/welfarePurchaseContract/welfarePurchaseContract.vue'), meta:['支出合同管理','福利采购合同']},//合同管理-福利采购合同
      {path: 'otherProcurementContracts',      name: 'otherProcurementContracts',      component:()=>import('../views/customerSystem/contractManage/expenditureContractManage/otherProcurementContracts/otherProcurementContracts.vue'), meta:['支出合同管理','其他采购合同']},//合同管理-其他采购合同
      {path: 'sysProjectInfoManage',           name: 'sysProjectInfoManage',           component:()=>import('../views/customerSystem/sysProjectInfo/sysProjectInfoManage/sysProjectInfoManage.vue'), meta:['项目管理','项目信息管理']},//立项信息-有新增功能
      {path: 'projectApprovalTODOSC',          name: 'projectApprovalTODOSC',          component:()=>import('../views/customerSystem/sysProjectInfo/sysProjectInfoTODOSC/sysProjectInfoTODOSC.vue'), meta:['项目管理','项目信息审核-市场部']},//立项信息代办-市场部
      {path: 'projectApprovalTODOYW',          name: 'projectApprovalTODOYW',          component:()=>import('../views/customerSystem/sysProjectInfo/sysProjectInfoTODOYW/sysProjectInfoTODOYW.vue'), meta:['项目管理','项目信息审核-业务部']},//立项信息代办-业务部
      {path: 'sysProjectInfoChangeTODO',       name: 'sysProjectInfoChangeTODO',       component:()=>import('../views/customerSystem/sysProjectInfo/sysProjectInfoChangeTODO/sysProjectInfoChangeTODO.vue'), meta:['项目管理','项目信息修改审核']},//立项信息代办-业务部
      {path: 'financialSettlementGenerate',    name: 'financialSettlementGenerate',         component:()=>import('../views/staffSystem/staffWageManageModule/financialSettlementGenerate/financialSettlementGenerate.vue'),meta:['结算管理','结算数据生成']},//结算数据生成
      {path: 'financialSettlementRule',        name: 'financialSettlementRule',         component:()=>import('../views/staffSystem/staffWageManageModule/financialSettlementRule/financialSettlementRule.vue'),meta:['结算管理','结算数据生成规则']},//结算数据生成规则
      {
        path: 'financialSettlementNew',
        name: 'financialSettlementNew',
        component: () => import('../views/staffSystem/staffWageManageModule/financialSettlement/financialSettlementNew.vue'),
        meta: ['结算管理', '结算数据维护']
      },//结算数据维护
      {
        path: 'financialSettlementAuditYW',
        name: 'financialSettlementAuditYW',
        component: () => import('../views/staffSystem/staffWageManageModule/financialSettlement/financialSettlementAuditYW.vue'),
        meta: ['结算管理', '结算数据审核-业务']
      },//财务结算数据审核
      {
        path: 'financialSettlementAuditYWFirst',
        name: 'financialSettlementAuditYWFirst',
        component: () => import('../views/staffSystem/staffWageManageModule/financialSettlement/financialSettlementAuditYWFirst.vue'),
        meta: ['结算管理', '结算数据审核-业务初审']
      },//财务结算数据审核
      {
        path: 'financialSettlementAuditCW',
        name: 'financialSettlementAuditCW',
        component: () => import('../views/staffSystem/staffWageManageModule/financialSettlement/financialSettlementAuditCW.vue'),
        meta: ['结算管理', '结算数据审核-财务']
      },//财务结算数据审核
      {
        path: 'aiManage',
        name: 'aiManage',
        component: () => import('../views/powerSystem/aiManage/aiManage.vue'),
        meta: ['系统管理', 'AI助手管理']
      },
      {
        path: 'juesemanage',
        name: 'juesemanage',
        component: () => import('../views/powerSystem/rolemanage/RoleManage.vue'),
        meta: ['系统管理', '角色及权限管理']
      },
      {
        path: 'fzrmanage',
        name: 'fzrmanage',
        component: () => import('../views/powerSystem/accountManage/fzrmanage.vue'),
        meta: ['账号管理', '业务员账号管理']
      },//业务员账号管理
      {
        path: 'mobileAccountManage',
        name: 'mobileAccountManage',
        component: () => import('../views/powerSystem/accountManage/mobileAccountManage.vue'),
        meta: ['账号管理', '移动端账号管理']
      },
      {
        path: 'sysStatusManage',
        name: 'sysStatusManage',
        component: () => import('../views/powerSystem/sysStatusManage/sysStatusManage.vue'),
        meta: ['字典管理', '数据字典']
      },
      {
        path: 'sysModuleManage',
        name: 'sysModuleManage',
        component: () => import('../views/powerSystem/sysModuleManage/sysModuleManage.vue'),
        meta: ['系统管理', '系统菜单管理']
      },
      {
        path: 'sysModuleInterface',
        name: 'sysModuleInterface',
        component: () => import('../views/powerSystem/sysModuleInterface/sysModuleInterface.vue'),
        meta: ['系统管理', '菜单接口权限管理']
      },
      {
        path: 'orgInfo',
        name: 'orgInfo',
        component: () => import('../views/powerSystem/sysOrganizationInfo/sysOrganizationInfoManage.vue'),
        meta: ['系统管理', '组织架构管理']
      },//组织信息
      {
        path: 'pcOperationNote',
        name: 'pcOperationNote',
        component: () => import('../views/powerSystem/dataHub/pcOperationNote.vue'),
        meta: ['操作日志']
      },
      {
        path: 'sysDataSynchronization',
        name: 'sysDataSynchronization',
        component: () => import('../views/financeSystem/sysDataSynchronization/sysDataSynchronization.vue'),
        meta: ['系统管理', '同步监控']
      },//同步监控
      {path: 'datainfo', name: 'datainfo', component: () => import('../views/powerSystem/dataHub/datainfo.vue')},
      {
        path: 'fzrdetail',
        name: 'fzrdetail',
        component: () => import('../views/powerSystem/accountManage/fzrdetail.vue')
      },
      {
        path: 'childProject',
        name: 'childProject',
        component: () => import('../views/powerSystem/accountManage/childProject.vue')
      },
      {
        path: 'operationDocumentManage',
        name: 'operationDocumentManage',
        component: () => import('../views/powerSystem/othersmanage/operationDocumentManage.vue'),
        meta: ['系统管理', '操作文档']
      },
      {
        path: 'sysDataSynchronization',
        name: 'sysDataSynchronization',
        component: () => import('../views/financeSystem/sysDataSynchronization/sysDataSynchronization.vue')
      },//同步监控
      {
        path: 'costReimbursement',
        name: 'costReimbursement',
        component: () => import('../views/financeSystem/sysDataSynchronization/costReimbursement.vue'),
        meta: ['支付管理', '成本报账单同步流水']
      },//成本报账单
      {
        path: 'paymentBill',
        name: 'paymentBill',
        component: () => import('../views/financeSystem/sysDataSynchronization/paymentBill.vue'),
        meta: ['支付管理', '付款单同步流水']
      },//成本报账单
      {path: 'seeproject',                     name: 'seeproject',                     component:()=>import('../views/powerSystem/accountManage/seeproject.vue')},
      {path: 'modifypassword',                 name: 'modifypassword',                 component:()=>import('../views/others/ModifyPassword/ModifyPassword.vue')},
      {path: 'roleManageRE',                   name: 'roleManageRE',                   component:()=>import('../views/powerSystem/rolemanage/roleManageRE.vue')},
      {path: 'seeprojecttwo',                  name: 'seeprojecttwo',                  component:()=>import('../views/powerSystem/accountManage/seeprojecttwo.vue')},
      {path: 'operationnote',                  name: 'operationnote',                  component:()=>import('../views/powerSystem/dataHub/operationnote.vue')},
      {path: 'operationManual',                name: 'operationManual',                component:()=>import('../views/powerSystem/othersmanage/operationManual.vue')},
      {path: 'operationalInformation',         name: 'operationalInformation',         component:()=>import('../views/powerSystem/operationManage/operationInformation.vue'), meta:['系统管理','运营信息']},//运营信息
      {path: 'wxTemplateMessage',              name: 'wxTemplateMessage',              component:()=>import('../views/staffSystem/templateMessage/wxTemplateMessage.vue'),meta:['消息通知中心','微信模板消息']},//微信模板消息
      {path: 'wxTemplateMessageDetails',       name: 'wxTemplateMessageDetails',       component:()=>import('../views/staffSystem/templateMessage/wxTemplateMessageDetails.vue'),meta: ['微信模板消息详情']},//微信模板消息详情
      {path: 'customerAccountInfo',            name: 'customerAccountInfo',            component:()=>import('../views/customerSystem/customerAccountManage/customerAccountInfo.vue'), meta:['账号管理','灵工移动端客户账号管理']},//客户账号管理
      {path: 'sysSupplierChargeManage',        name: 'sysSupplierChargeManage',        component:()=>import('../views/powerSystem/sysSupplierChargeManage/sysSupplierChargeManage.vue'), meta:['系统管理','灵工发放平台权限管理']},//灵工发放平台权限管理
      {
        path: 'sysExpirationTimeConfiguration',
        name: 'sysExpirationTimeConfiguration',
        component: () => import('../views/customerSystem/sysConfigurationModule/sysExpirationTimeConfiguration.vue'),
        meta: ['系统配置管理', '到期时间配置管理']
      },
      {
        path: 'financialOurPaymentInformation',
        name: 'financialOurPaymentInformation',
        component: () => import('../views/financeSystem/financialOurPaymentInformation/financialOurPaymentInformation.vue'),
        meta: ['付款管理', '付款信息']
      },
      {
        path: 'fileinfo',
        name: 'fileinfo',
        component: () => import('../views/staffSystem/informmanage/informinfo/fileinfo.vue'),
        meta: ['通知管理', '通知信息']
      },
      {
        path: 'sysConfirmFddTemplate',
        name: 'sysConfirmFddTemplate',
        component: () => import('../views/staffSystem/staffConfirmFile/sysConfirmFileFddTemplate/sysConfirmFddTemplate.vue'),
        meta: ['通知管理', '电子签模板管理']
      },//电子证明模板管理
      {
        path: 'noticeInfo',
        name: 'noticeInfo',
        component: () => import('../views/customerSystem/noticeInfoManage/noticeInfo.vue'),
        meta: ['通知管理', '通知信息']
      },//电子证明模板管理
      {
        path: 'questionnaireSurvey',
        name: 'questionnaireSurvey',
        component: () => import('../views/customerSystem/questionnaireSurveyModule/questionnaireSurvey.vue'),
        meta: ['问卷调研', '问卷调研信息']
      },
      {
        path: 'customerAccountManage',
        name: 'customerAccountManage',
        component: () => import('../views/customerSystem/customerAccountManage/customerAccountManage.vue'),
        meta: ['账号管理', '客户账号管理']
      },//客户账号管理
      {
        path: 'LgSupplierAccountManage',
        name: 'LgSupplierAccountManage',
        component: () => import('../views/powerSystem/accountManage/LgSupplierAccountManage.vue'),
        meta: ['账号管理', '灵工供应商账号管理']
      },//供应商账号管理
      {
        path: 'welfareSupplierAccountManage',
        name: 'welfareSupplierAccountManage',
        component: () => import('../views/powerSystem/accountManage/welfareSupplierAccountManage.vue'),
        meta: ['账号管理', '福利供应商账号管理']
      },//供应商账号管理
      {
        path: 'LgClientAccountManage',
        name: 'LgClientAccountManage',
        component: () => import('../views/powerSystem/accountManage/LgClientAccountManage.vue'),
        meta: ['账号管理', '灵工客户端账号管理']
      },//灵工客户端账号管理
      {
        path: 'LgClientAccountDetail',
        name: 'LgClientAccountDetail',
        component:()=>import('../views/powerSystem/accountManage/LgClientAccountDetail.vue')
      },
      {
        path: 'LgSupplierAccountDetail',
        name: 'LgSupplierAccountDetail',
        component: () => import('../views/powerSystem/accountManage/LgSupplierAccountDetail.vue')
      },
      {
        path: 'customerAccountDetail',
        name: 'customerAccountDetail',
        component: () => import('../views/customerSystem/customerAccountManage/customerAccountDetail.vue')
      },
      {
        path: 'fddContractDeleteAudit',
        name: 'fddContractDeleteAudit',
        component: () => import('../views/staffSystem/staffContractModule/fddContractDeleteAudit/fddContractDeleteAudit.vue'),
        meta: ['劳动关系', '电子合同删除审核']
      },//电子合同
      {
        path: 'sysUpdateNoticeManage',
        name: 'sysUpdateNoticeManage',
        component: () => import('../views/powerSystem/sysUpdateNoticeManage/sysUpdateNoticeManage.vue'),
        meta: ['系统管理', '版本更新通知']
      },//版本更新通知
      {
        path: 'sysPasswordChangeLog',
        name: 'sysPasswordChangeLog',
        component: () => import('../views/powerSystem/sysPasswordChangeLog/sysPasswordChangeLog.vue'),
        meta: ['系统管理', '密码修改日志']
      },//版本更新通知
      {
        path: 'organizationSignature',
        name: 'organizationSignature',
        component: () => import('../views/staffSystem/staffContractModule/fddContract/organizationSignature/organizationSignature.vue'),
        meta: ['电子合同管理', '机构印章信息']
      },
      {
        path: 'sysDataRightManage',
        name: 'sysDataRightManage',
        component: () => import('../views/powerSystem/sysDataRightManage/sysDataRightManage.vue'),
        meta: ['系统管理', '数据权限管理']
      },
      {
        path: 'dataRightDetail',
        name: 'dataRightDetail',
        component: () => import('../views/powerSystem/sysDataRightManage/dataRightDetail.vue')
      },
      {
        path: 'sysModuleLogManage',
        name: 'sysModuleLogManage',
        component: () => import('../views/powerSystem/sysModuleLogManage/sysModuleLogManage.vue'),
        meta: ['系统管理', '用户操作模块使用记录']
      },
      {
        path: 'sysEnterpriseManagement',
        name: 'sysEnterpriseManagement',
        component: () => import('../views/powerSystem/sysEnterpriseManage/sysEnterpriseManagement.vue'),
        meta: ['企业管理', '企业信息管理']
      },
      {
        path: 'financialFundAdvancePayment',
        name: 'financialFundAdvancePayment',
        component: () => import('../views/financeSystem/financialFundAdvancePaymentModule/financialFundAdvancePayment.vue'),
        meta: ['资金垫付管理', '资金垫付申请']
      },
      {
        path: 'sysBackUpDataReview',
        name: 'sysBackUpDataReview',
        component: () => import('../views/powerSystem/sysBackupManage/sysBackUpDataReviewList.vue'),
        meta: ['数据备份管理', '省通服备份数据审核']
      },
      {
        path: 'sysBackUpJdTaxInvoiceList',
        name: 'sysBackUpJdTaxInvoiceList',
        component: () => import('../views/financeSystem/sysBackUpJdTaxInvoiceModule/sysBackUpJdTaxInvoiceList.vue'),
        meta: ['发票信息', '发票列表']
      },
      {
        path: 'sysBackUpJdProjectIncomeList',
        name: 'sysBackUpJdProjectIncomeList',
        component: () => import('../views/financeSystem/sysBackUpJdProjectIncomeModule/sysBackUpJdProjectIncomeList.vue'),
        meta: ['收款信息', '收款列表']
      },
      {
        path: 'backupAccountManage',
        name: 'backupAccountManage',
        component: () => import('../views/powerSystem/accountManage/backupAccountManage.vue'),
        meta: ['账号管理', '数据备份账号管理']
      },//供应商账号管理
      {
        path: 'bankAccountManage',
        name: 'bankAccountManage',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxComputeConfig/bankAccountManage.vue'),
        meta: ['工资计算配置', '银行账号配置']
      },//工资配置-银行账号管理
      {
        path: 'compensationTaxExemptManage',
        name: 'compensationTaxExemptManage',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxComputeConfig/compensationTaxExemptManage.vue'),
        meta: ['工资计算配置', '经济补偿金免税额配置']
      },//工资配置-经济补偿金免税额配置
      {
        path: 'tradeConfirmSealConfigManage',
        name: 'tradeConfirmSealConfigManage',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxComputeConfig/tradeConfirmSealConfigManage.vue'),
        meta: ['工资计算配置', '交易确认单盖章配置']
      },//工资配置-经济补偿金免税额配置
      {
        path: 'kingdeeOrgCodeManage',
        name: 'kingdeeOrgCodeManage',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxComputeConfig/kingdeeOrgCodeManage.vue'),
        meta: ['工资计算配置', '金蝶组织编码配置']
      },//工资配置-金蝶组织编码配置
      {
        path: 'companyRatioManage',
        name: 'companyRatioManage',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxComputeConfig/companyRatioManage.vue'),
        meta: ['工资计算配置', '单位社保险种比例配置管理']
      },//工资配置-单位社保险种比例配置管理
      {
        path: 'personalRatioManage',
        name: 'personalRatioManage',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxComputeConfig/personalRatioManage.vue'),
        meta: ['工资计算配置', '个人社保险种比例配置管理']
      },//工资配置-个人社保险种比例配置管理
      {
        path: 'orgBankAccountManage',
        name: 'orgBankAccountManage',
        component: () => import('../views/staffSystem/staffWageManageModule/taxCompute/taxComputeConfig/orgBankAccountManage.vue'),
        meta: ['工资计算配置', '组织对应银行账号配置管理']
      },//工资配置-组织对应银行账号配置管理
      {
        path: 'financialInvoiceManagement',
        name: 'financialInvoiceManagement',
        component: () => import('../views/financeSystem/financialInvoiceModule/financialInvoiceManagement.vue'),
        meta: ['发票管理', '增值税发票列表']
      },//发票维护
       {
        path: 'ztfUploadReview',
        name: 'ztfUploadReview',
        component: () => import('../views/powerSystem/ztfUpload/ztfUploadReviewList.vue'),
        meta: ['数据上传管理', '中通服上传数据']
      },
      {
        path: 'ztfSystemApprovalList',
        name: 'ztfSystemApprovalList',
        component: () => import('../views/powerSystem/ztfUpload/ztfUploadApprovalDetail.vue'),
        meta: ['数据上传管理', '中通服上传数据审核']
      },
    ]
  },


  {//灵活用工业务系统
    path: '/costPlanningBusinessSystem', name: 'costPlanningBusinessSystem',   component:()=>import('../components/stonghrSysMenu/costPlanningBusinessSystem.vue'), redirect:'costPlanningBusinessSystem/customHome',
    children: [
      {path: 'welcome',                         name: 'welcome',                         component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'customHome',                      name: 'customHome',                      component:()=>import('../views/others/home/customHome.vue'),meta: ['灵工首页']},
      {path: 'personnelGroupManagement',        name: 'personnelGroupManagement',        component:()=>import('../views/lgSystem/personnelManagement/personnelGroupManagement/personnelGroupManagement.vue'), meta:[{keepAlive: true},'人员分组管理']},  //路由需要被缓存
      {path: 'projectStaffInfoList',            name: 'projectStaffInfoList',            component:()=>import('../views/lgSystem/personnelManagement/personnelGroupManagement/projectStaffInfoList.vue'), meta:['人员管理','人员分组管理','人员列表']},
      {path: 'personnelGroupQuery',             name: 'personnelGroupQuery',             component:()=>import('../views/lgSystem/personnelManagement/personnelGroupQuery/personnelGroupQuery.vue'), meta:[{keepAlive: true},'人员分组查询']}, //路由需要被缓存
      {path: 'projectStaffInfoListQuery',       name: 'projectStaffInfoListQuery',       component:()=>import('../views/lgSystem/personnelManagement/personnelGroupQuery/projectStaffInfoListQuery.vue'), meta:['人员管理','人员分组查询','人员列表']},
      {path: 'personnelInformationMaintenance', name: 'personnelInformationMaintenance', component:()=>import('../views/lgSystem/personnelManagement/personnelInformationMaintenance/personnelInformationMaintenance.vue'), meta:['人员管理','人员信息维护']},
      {path: 'personnelInformationInquiry',     name: 'personnelInformationInquiry',     component:()=>import('../views/lgSystem/personnelManagement/personnelInformationInquiry/personnelInformationInquiry.vue'), meta:['人员管理','人员信息查询']},
      {path: 'staffinfo1',                      name: 'staffinfo1',                      component:()=>import('../views/staffSystem/staffManageModule/staffInfo/staffinfo.vue')},
      {path: 'projectInformation',              name: 'projectInformation',              component:()=>import('../views/lgSystem/projectManagement/projectInformation/projectInformation.vue'), meta:['项目管理','项目维护']},//业务管理-项目管理
      {path: 'projectInformationReadOnly',      name: 'projectInformationReadOnly',      component:()=>import('../views/lgSystem/projectManagement/projectInformation/projectInformationReadOnly.vue'), meta:['项目管理','项目信息']},//业务管理-项目管理
      {path: 'safeTrainList',                   name: 'safeTrainList',                   component:()=>import('../views/lgSystem/safetyManagement/safeTrain/safeTrainList.vue'), meta:['安全管理','安全培训记录','安全培训记录列表']},//安全管理-安全培训记录管理
      {path: 'safeTrainManage',                 name: 'safeTrainManage',                 component:()=>import('../views/lgSystem/safetyManagement/safeTrain/safeTrainManage.vue'), meta:['安全管理','安全培训记录']},//安全管理-安全培训记录管理
      {path: 'safeTrainInquiry',                name: 'safeTrainInquiry',                component:()=>import('../views/lgSystem/safetyManagement/safeTrain/safeTrainInquiry.vue'), meta:['安全管理','安全培训记录']},//安全管理-安全培训记录查询
      {path: 'safeConfessionList',              name: 'safeConfessionList',              component:()=>import('../views/lgSystem/safetyManagement/safeConfession/safeConfessionList.vue'), meta:['安全管理','安全交底','安全交底列表']},//安全管理-安全交底管理
      {path: 'safeConfessionManage',            name: 'safeConfessionManage',            component:()=>import('../views/lgSystem/safetyManagement/safeConfession/safeConfessionManage.vue'), meta:['安全管理','安全交底']},//安全管理-安全交底管理
      {path: 'safeConfessionInquiry',           name: 'safeConfessionInquiry',           component:()=>import('../views/lgSystem/safetyManagement/safeConfession/safeConfessionInquiry.vue'), meta:['安全管理','安全交底']},//安全管理-安全交底查询
      {path: 'BSIMessage',                      name: 'BSIMessage',                      component:()=>import('../views/staffSystem/BusinessInsuranceManage/BusinessInsuranceInformation.vue'),meta:['商保管理','项目人员商保情况']},
      {path: 'commercialInsuranceStaffInfoLG',  name: 'commercialInsuranceStaffInfoLG',  component:()=>import('../views/staffSystem/commercialInsurance/commercialInsuranceStaffInfo/commercialInsuranceStaffInfoLG.vue'),meta:['商保管理','商保维护-业务员']},//商保
      {path: 'commercialInsuranceProjectLG',    name: 'commercialInsuranceProjectLG',    component:()=>import('../views/staffSystem/commercialInsurance/commercialInsuranceProject/commercialInsuranceProjectLG.vue'),meta:['商保管理','商保包信息']},//商保
      {path: 'commercialInsuranceRollCall',     name: 'commercialInsuranceRollCall',     component:()=>import('../views/staffSystem/commercialInsurance/commercialInsuranceRollCall/commercialInsuranceStaffInfoLG.vue'),meta:['商保管理','商保名单']},
      {path: 'BSIIncreaseOrDecrease',           name: 'BSIIncreaseOrDecrease',           component:()=>import('../views/customerSystem/businessInsuranceManage/BSIIncreaseOrDecrease.vue')},
      {path: 'safeConfessionAudit',             name: 'safeConfessionAudit',             component:()=>import('../views/lgSystem/safetyManagement/safeConfession/safeConfessionAudit.vue'), meta:['安全管理','安全交底材料审核']},//安全管理-安全交底材料审核
      {path: 'safeTrainAudit',                  name: 'safeTrainAudit',                  component:()=>import('../views/lgSystem/safetyManagement/safeTrain/safeTrainAudit.vue'), meta:['安全管理','安全培训材料审核']},//安全管理-安全培训材料审核
      {path: 'lgMyCertificate',                 name: 'lgMyCertificate',                 component:()=>import('../views/lgSystem/safetyManagement/lgMyCertificate/lgMyCertificate.vue'), meta:['安全管理','工作证管理']},//安全管理-工作证管理
      {path: 'employmentAgreementNoSignature',  name: 'employmentAgreementNoSignature',  component:()=>import('../views/lgSystem/employmentAgreement/employmentAgreementNoSignature/employmentAgreementNoSignature.vue'), meta:['电子协议管理','待签就业协议']},
      {path: 'employmentAgreementExpired',      name: 'employmentAgreementExpired',      component:()=>import('../views/lgSystem/employmentAgreement/employmentAgreementExpired/employmentAgreementExpired.vue'), meta:['电子协议管理','到期就业协议']},
      {path: 'employmentAgreementNotExist',     name: 'employmentAgreementNotExist',     component:()=>import('../views/lgSystem/employmentAgreement/employmentAgreementNotExist/employmentAgreementNotExist.vue'), meta:['电子协议管理','暂无就业协议']},
      {path: 'employmentAgreementInfo',         name: 'employmentAgreementInfo',         component:()=>import('../views/lgSystem/employmentAgreement/employmentAgreementInfo/employmentAgreementInfo.vue'), meta:['电子协议管理','协议信息查询']},
      {path: 'employmentAgreementManagement',   name: 'employmentAgreementManagement',   component:()=>import('../views/lgSystem/employmentAgreement/employmentAgreementManagement/employmentAgreementManagement.vue'), meta:['电子协议管理','协议管理']},
      {path: 'LgRequirement',                   name: 'LgRequirement',                   component:()=>import('../views/lgSystem/requirementManagement/LgRequirement.vue'), meta:['公众需求管理','需求信息']},
      {
        path: 'LgRequirementHome',
        name: 'LgRequirementHome',
        component: () => import('../views/lgSystem/requirementManagement/LgRequirementHome.vue'),
        meta: ['公众需求管理', '公众首页']
      },
      {
        path: 'workloadDistribution',
        name: 'workloadDistribution',
        component: () => import('../views/lgSystem/workloadDistributionManagement/workloadDistribution/workloadDistribution.vue'),
        meta: ['工作量管理', '工作量分配']
      },
      {
        path: 'workloadApproval',
        name: 'workloadApproval',
        component: () => import('../views/lgSystem/workloadDistributionManagement/workloadApproval/workloadApproval.vue'),
        meta: ['工作量管理', '工作量审批']
      },
      {
        path: 'workloadApprovalCustomerFinance',
        name: 'workloadApprovalCustomerFinance',
        component: () => import('../views/lgSystem/workloadDistributionManagement/workloadApprovalCustomerFinance/workloadApprovalCustomerFinance.vue'),
        meta: ['工作量管理', '工作量审批']
      },
      {
        path: 'workloadApprovalCustomerBranch',
        name: 'workloadApprovalCustomerBranch',
        component: () => import('../views/lgSystem/workloadDistributionManagement/workloadApprovalCustomerBranch/workloadApprovalCustomerBranch.vue'),
        meta: ['工作量管理', '工作量审批']
      },
      {
        path: 'workloadStatistics',
        name: 'workloadStatistics',
        component: () => import('../views/lgSystem/workloadDistributionManagement/workloadStatistics/workloadStatistics.vue'),
        meta: ['工作量管理', '工作量统计']
      },
      {
        path: 'c_financialOurPaymentInformation',
        name: 'c_financialOurPaymentInformation',
        component: () => import('../views/customerServiceSystem/financialOuerPaymentInformation/c_financialOurPaymentInformation.vue'),
        meta: ['付款管理', '付款信息']
      },//付款信息
      {
        path: 'invoiceManagement',
        name: 'invoiceManagement',
        component: () => import('../views/lgSystem/invoiceManagement/invoiceManagement.vue'),
        meta: ['发票管理', '发票维护']
      },
      {
        path: 'issueManagement',
        name: 'issueManagement',
        component: () => import('../views/lgSystem/issueManagement/issueManagement/issueManagement.vue'),
        meta: ['支付管理', '支付维护']
      },
      {
        path: 'distributionDetailsList',
        name: 'distributionDetailsList',
        component: () => import('../views/lgSystem/distributionManagement/distributionDetailsList.vue'),
        meta: ['支付管理', '工资明细']
      },//支付管理-工资明细
      {
        path: 'subcontractingBusinessWithInvoiceList',
        name: 'subcontractingBusinessWithInvoiceList',
        component: () => import('../views/lgSystem/issueManagement/subcontractingBusinessWithInvoice/subcontractingBusinessWithInvoiceList.vue'),
        meta: ['分包业务', '对公支付-有发票']
      },
      {
        path: 'subcontractingBusinessNoInvoiceList',
        name: 'subcontractingBusinessNoInvoiceList',
        component: () => import('../views/lgSystem/issueManagement/subcontractingBusinessNoInvoice/subcontractingBusinessNoInvoiceList.vue'),
        meta: ['分包业务', '对公支付-无发票']
      },
      {
        path: 'partialDistributionList',
        name: 'partialDistributionList',
        component: () => import('../views/lgSystem/issueManagement/partialDistribution/partialDistributionList.vue'),
        meta: ['非全业务', '非全业务-非全发放']
      },
      {
        path: 'issueHandle',
        name: 'issueHandle',
        component: () => import('../views/lgSystem/issueManagement/issueHandle/issueHandle.vue'),
        meta: ['支付管理', '支付管理-云南分公司']
      },
      {
        path: 'issueSubmission',
        name: 'issueSubmission',
        component: () => import('../views/lgSystem/issueManagement/issueSubmission/issueSubmission.vue'),
        meta: ['支付管理', '业务提交']
      },
      {
        path: 'issueManagementSTJ',
        name: 'issueManagementSTJ',
        component: () => import('../views/lgSystem/issueManagement/issueManagementSTJ/issueManagementSTJ.vue'),
        meta: ['支付管理', '支付管理-胜通建']
      },
      {
        path: 'partialDistributionSTJ',
        name: 'partialDistributionSTJ',
        component: () => import('../views/lgSystem/issueManagement/partialDistributionSTJ/partialDistributionList.vue'),
        meta: ['支付管理', '非全发放-胜通建']
      },
      {
        path: 'updateIncomeCategoryCheck',
        name: 'updateIncomeCategoryCheck',
        component: () => import('../views/lgSystem/issueManagement/updateIncomeCategoryCheck/updateIncomeCategoryCheck.vue'),
        meta: ['支付管理', '收入类别修改审核']
      },
      {
        path: 'issueTelecom',
        name: 'issueTelecom',
        component: () => import('../views/lgSystem/issueManagement/issueTelecom/issueTelecom.vue'),
        meta: ['支付管理', '支付列表-电信']
      },
      {
        path: 'projectDeliverables',
        name: 'projectDeliverables',
        component: () => import('../views/lgSystem/projectManagement/deliverablesManagement/projectDeliverables.vue'),
        meta: ['项目管理', '项目交付']
      },
      {
        path: 'paymentManagement',
        name: 'paymentManagement',
        component: () => import('../views/lgSystem/paymentManagement/paymentManagement.vue'),
        meta: ['到款管理', '项目到款信息']
      },
      {
        path: 'businessManagement',
        name: 'businessManagement',
        component: () => import('../views/lgSystem/businessManagement/businessManagement.vue'),
        meta: ['业务管理', '业务维护']
      },
      {
        path: 'businessCondition',
        name: 'businessCondition',
        component: () => import('../views/lgSystem/businessManagement/businessCondition.vue'),
        meta: ['业务管理', '业务情况']
      },
      {
        path: 'businessTask',
        name: 'businessTask',
        component: () => import('../views/lgSystem/businessManagement/businessTask.vue'),
        meta: ['业务管理', '任务管理']
      },
      //addon
      {
        path: 'lgBiz_formQuery',
        name: 'lgBiz_formQuery',
        component: () => import('../addon/views/lgBiz/formQuery.vue'),
        meta: ['业务管理', '业务录单']
      },
      {
        path: 'lgBiz_financeMan',
        name: 'lgBiz_financeMan',
        component: () => import('../addon/views/lgBiz/financeMan.vue'),
        meta: ['业务管理', '财务功能']
      },
      {
        path: 'lgBiz_costQuery',
        name: 'lgBiz_costQuery',
        component: () => import('../addon/views/lgBiz/costQuery.vue'),
        meta: ['业务管理', '成本管理']
      },
      {
        path: 'LgZTJSynchronizationWorkOrderIssueList',
        name: 'LgZTJSynchronizationWorkOrderIssueList',
        component: () => import('../views/lgSystem/ztjDocumentManagement/LgZTJSynchronizationWorkOrderIssue/LgZTJSynchronizationWorkOrderIssueList.vue'),
        meta: ['工单劳务发放管理', '劳务发放列表']
      },
      {
        path: 'LgZTJSynchronizationWorkOrderDistributionList',
        name: 'LgZTJSynchronizationWorkOrderDistributionList',
        component: () => import('../views/lgSystem/ztjDocumentManagement/LgZTJSynchronizationWorkOrderDistribution/LgZTJSynchronizationWorkOrderDistributionList.vue'),
        meta: ['工单劳务发放管理', '发放明细']
      },
    ]
  },


  {//招聘业务系统
    path: '/recruitmentBusinessSystem',        name: 'recruitmentBusinessSystem',      component:()=>import('../components/stonghrSysMenu/recruitmentBusinessSystem.vue'),
    children: [
      {path: 'welcome',                        name: 'welcome',                        component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'programming3',                   name: 'programming3',                   component:()=>import('../views/others/programming/programming.vue')},
      {path: 'recruitInfo',                    name: 'recruitInfo',                    component:()=>import('../views/staffSystem/recruitManage/recruitInfo.vue'),meta:['招聘管理','招聘信息维护']},//招聘信息
      {path: 'recruitInfoResume',              name: 'recruitInfoResume',              component:()=>import('../views/staffSystem/recruitManage/resume/recruitInfoResume.vue'),},//简历信息
      {path: 'recruitInfoMonitor',             name: 'recruitInfoMonitor',             component:()=>import('../views/staffSystem/recruitManage/recruitInfoMonitor/recruitInfoMonitor.vue'),meta:['招聘业务系统','招聘信息统计']},//招聘信息统计
      {path: 'recruitmentManagement',          name: 'recruitmentManagement',          component:()=>import('../views/staffSystem/recruitManage/recruitmentManagement/recruitmentManagement.vue'),meta: ['招聘业务系统','应聘人员管理']},
      {path: 'recruitmentManagementYW',        name: 'recruitmentManagementYW',        component:()=>import('../views/staffSystem/recruitManage/recruitmentManagement/recruitmentManagementYW.vue'),meta: ['招聘业务系统','应聘人员管理-业务']},
      {path: 'candidatesPositionManagement',  name: 'candidatesPositionManagement',  component:()=>import('../views/staffSystem/recruitManage/candidatesPositionManagement/candidatesPositionManagement.vue'),meta: ['招聘业务系统','客户需求管理']},
      { path: 'RMForSearch/:id', name: 'RMForSearch', component: () => import('../views/staffSystem/recruitManage/recruitmentManagement/recruitmentManagementForSearch.vue') },
      {path: 'recruitStaffDimissionSurvey',    name: 'recruitStaffDimissionSurvey',    component:()=>import('../views/recruitSystem/recruitStaffDimissionSurvey/recruitStaffDimissionSurvey.vue'),meta: ['招聘业务系统','离职调查管理']},
      {path: 'recruitInfosManagement',         name: 'recruitInfosManagement',         component:()=>import('../views/staffSystem/recruitManage/recruitInfosManagement/recruitInfosManagement.vue'),meta: ['招聘业务系统','职位管理']},
      {path: 'recruitInfosResumeManagement',   name: 'recruitInfosResumeManagement',   component:()=>import('../views/staffSystem/recruitManage/recruitInfosResumeManagement/recruitInfosResumeManagement.vue')},

    ]
  },


  {//培训业务系统
    path: '/trainingBusinessSystem',                name: 'trainingBusinessSystem',              component:()=>import('../components/stonghrSysMenu/trainingBusinessSystem.vue'),
    children: [
      {path: 'welcome',                             name: 'welcome',                             component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'programming5',                        name: 'programming5',                        component:()=>import('../views/others/programming/programming.vue')},
      {path: 'trainInfoManage',                     name: 'trainInfoManage',                     component:()=>import('../views/staffSystem/trainManage/trainInfo/trainInfoManage'),meta:['培训业务系统','培训课程管理']},
      {path: 'staffTrainStatistic',                 name: 'staffTrainStatistic',                 component:()=>import('../views/staffSystem/trainManage/staffTrainStatistic/staffTrainStatistic.vue'),meta:['培训管理','项目统计']},
      {path: 'staffTrainProfileStatistic',          name: 'staffTrainProfileStatistic',          component:()=>import('../views/staffSystem/trainManage/staffTrainStatistic/staffTrainProfileStatistic.vue'),meta:['培训管理','人员概况']},
      {path: 'trainFeedbackData',                   name: 'trainFeedbackData',                   component:()=>import('../views/staffSystem/trainManage/trainingExamManagement/trainFeedbackData/trainFeedbackData.vue'),meta:['考试管理','考试反馈']},
      {path: 'trainersInfo',                        name:'trainersInfo',                         component:()=>import("../views/staffSystem/trainManage/trainersInfo/trainersInfo.vue"),meta:['培训业务系统','培训人员信息']},//培训人员信息
      {path: 'addTrain',                            name: 'addTrain',                            component:()=>import('../views/staffSystem/trainManage/addTrain/addTrain2.vue'),meta:['培训业务系统','新增培训']},
      {path: 'trainersIdCardInfo',                  name: 'trainersIdCardInfo',                  component:()=>import('../views/staffSystem/trainManage/trainInfo/trainersIdCardInfo.vue'),meta:['适岗培训管理','培训身份认证信息']},
      {path: 'trainingCourseInformation',           name: 'trainingCourseInformation',           component:()=>import('../views/staffSystem/trainManage/trainingCourseManagement/trainingCourseInformation.vue'),meta:['课程管理','课程库']},
      {path: 'questionBankInformation',             name: 'questionBankInformation',             component:()=>import('../views/staffSystem/trainManage/questionBankManagement/questionBankInformation.vue'),meta:['题库管理','题库']},
      {path: 'trainingVideoInformation',            name: 'trainingVideoInformation',            component:()=>import('../views/staffSystem/trainManage/trainingVideoManagement/trainingVideoInformation.vue'),meta:['课程管理','视频库']},
      {path: 'staffTrainInfo',                      name: 'staffTrainInfo',                      component:()=>import('../views/staffSystem/trainManage/trainingMemberManagement/staffTrainInfo.vue'),meta:['培训管理','培训项目']},
      {path: 'staffTrainExam',                      name: 'staffTrainExam',                      component:()=>import('../views/staffSystem/trainManage/trainingExamManagement/staffTrainExam.vue'),meta:['考试管理','考试信息']},
      {path: 'staffTrainExamManualMarking',         name: 'staffTrainExamManualMarking',         component:()=>import('../views/staffSystem/trainManage/trainingExamManagement/staffTrainExamManualMarking.vue'),meta:['考试管理','人工评卷']},
      {path: 'staffTrainExamResult',                name: 'staffTrainExamResult',                component:()=>import('../views/staffSystem/trainManage/trainingExamManagement/staffTrainExamResult.vue'),meta:['考试管理','考试结果信息']},

    ]
  },


  {//车辆租赁业务系统
    path: '/vehicleRentalBusinessSystem',            name: 'vehicleRentalBusinessSystem',          component:()=>import('../components/stonghrSysMenu/vehicleRentalBusinessSystem.vue'),
    children: [
      {path: 'welcome',                              name: 'welcome',                              component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'programming8',                         name: 'programming8',                         component:()=>import('../views/others/programming/programming.vue')},
      {path: 'carRentalProjectInformation',          name: 'carRentalProjectInformation',          component:()=>import('../views/carRentalSystem/projectManagement/carRentalProjectInformation.vue'), meta:['项目管理','项目维护']},
    ]
  },


  {//进销存业务系统
    path: '/welfareBusinessSystem',                 name: 'welfareBusinessSystem',               component:()=>import('../components/stonghrSysMenu/welfareBusinessSystem.vue'),
    children: [
      {path: 'welcome',                             name: 'welcome',                             component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'programming7',                        name: 'programming7',                        component:()=>import('../views/others/programming/programming.vue')},
      {path: 'psiProjectInformation',               name: 'psiProjectInformation',               component:()=>import('../views/purchaseSalesInventorySystem/psiProjectInformationModule/psiProjectInformation.vue'),meta:['业务项目管理','项目管理']},
      {path: 'collectionManagement',                name: 'collectionManagement',                component:()=>import('../views/purchaseSalesInventorySystem/collectionAndPaymentManagementModule/collectionManagement/collectionManagement.vue'),meta:['收付款管理','收款管理']},
      {path: 'paymentManagement',                   name: 'paymentManagement',                   component:()=>import('../views/purchaseSalesInventorySystem/collectionAndPaymentManagementModule/paymentManagement/paymentManagement.vue'),meta:['收付款管理','付款管理']},
      {path: 'accountStatement',                    name: 'accountStatement',                    component:()=>import('../views/purchaseSalesInventorySystem/accountStatementModule/accountStatement.vue'),meta:['对账单管理','对账单明细']},
      {path: 'warehousingManagement',               name: 'warehousingManagement',               component:()=>import('../views/purchaseSalesInventorySystem/warehousingAndDeliveryModule/warehousingManagement/warehousingManagement.vue'),meta:['进出库管理','进库明细']},
      {path: 'deliveryManagement',                  name: 'deliveryManagement',                  component:()=>import('../views/purchaseSalesInventorySystem/warehousingAndDeliveryModule/deliveryManagement/deliveryManagement.vue'),meta:['进出库管理','出库明细']},
      {path: 'profitSharingTable',                  name: 'profitSharingTable',                  component:()=>import('../views/purchaseSalesInventorySystem/statisticalAnalysisModule/profitSharingTable.vue'),meta:['统计分析','分润表']},
      {path: 'incomeAndProfitAnalysisTable',        name: 'incomeAndProfitAnalysisTable',        component:()=>import('../views/purchaseSalesInventorySystem/statisticalAnalysisModule/incomeAndProfitAnalysisTable.vue'),meta:['统计分析','收入利润分析表']},
      {path: 'commissionTable',                     name: 'commissionTable',                     component:()=>import('../views/purchaseSalesInventorySystem/statisticalAnalysisModule/commissionTable.vue'),meta:['统计分析','业务员提成表']},

    ]
  },


  {//统计分析系统
    path: '/statisticalAnalysisSystem',             name: 'statisticalAnalysisSystem',           component:()=>import('../components/stonghrSysMenu/statisticalAnalysisSystem.vue'),
    children: [
      {path: 'welcome', name: 'welcome', component: () => import('../views/others/welcome/welcome.vue')},
      {
        path: 'reportDSA',
        name: 'reportDSA',
        component: () => import('../views/statisticalAnalysisSystem/reportDSAModule/reportDSA.vue'),
        meta: ['统计分析', '服务数据统计与展示']
      },
      {
        path: 'enterpriseData',
        name: 'enterpriseData',
        component: () => import('../views/statisticalAnalysisSystem/enterpriseDataModule/enterpriseData.vue'),
        meta: ['统计分析', '企业数据统计与分析']
      },
      {
        path: 'operationAnalysis',
        name: 'operationAnalysis',
        component: () => import('../views/statisticalAnalysisSystem/statisticalAnalysisModule/operationAnalysis.vue'),
        meta: ['统计分析', '经营分析']
      },
      {
        path: 'financialSettlementFinanceData',
        name: 'financialSettlementFinanceData',
        component: () => import('../views/financeSystem/financialStatisticsModule/financialSettlementFinanceData.vue'),
        meta: ['统计分析', '经营表']
      },
      {
        path: 'findmonitordata',
        name: 'findmonitordata',
        component: () => import('../views/staffSystem/staffData/findMonitorData.vue'),
        meta: ['统计分析', '增减员统计']
      },//员工数量统计
      {
        path: 'persondatainfo',
        name: 'persondatainfo',
        component: () => import('../views/staffSystem/staffData/persondatainfo.vue'),
        meta: ['统计分析', '客户在岗人数统计']
      },//员工数量统计
      {
        path: 'staffInfoStatisticsGTF',
        name: 'staffInfoStatisticsGTF',
        component: () => import('../views/statisticalAnalysisSystem/staffInfoStatisticsModule/staffInfoStatisticsGTF.vue'),
        meta: ['统计分析', '广通服在岗人数统计']
      },
      {
        path: 'fddAnalysisMessage',
        name: 'fddAnalysisMessage',
        component: () => import('../views/statisticalAnalysisSystem/fddAnalysisModule/fddAnalysisMessage.vue'),
        meta: ['统计分析', '电子签统计信息']
      },//电子合同统计信息
    ]
  },

  {//进销存业务系统
    path: '/crmSystem',                 name: 'crmSystem',               component:()=>import('../components/stonghrSysMenu/crmSystem.vue'),
    children: [
      {path: 'welcome',                             name: 'welcome',                             component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'crm_customer_information',                  name: 'crm_customer_information',                  component:()=>import('../views/crmSystem/crm_customer_information.vue'),meta:['统计分析','客户信息']},
      {path: 'crm_customer_contact',                  name: 'crm_customer_contact',                  component:()=>import('../views/crmSystem/crm_customer_contact.vue'),meta:['客户关系管理系统','客户联系人']},
      {path: 'crm_clue_management',                  name: 'crm_clue_management',                  component:()=>import('../views/crmSystem/crm_clue_management.vue'),meta:['客户关系管理系统','线索管理']},
      {path: 'crm_clue_management_setting',                  name: 'crm_clue_management_setting',                  component:()=>import('../views/crmSystem/crm_clue_management_setting.vue'),meta:['客户关系管理系统','线索管理（爬虫配置）']},
      {path: 'crm_business_opportunity_management',                  name: 'crm_business_opportunity_management',                  component:()=>import('../views/crmSystem/crm_business_opportunity_management.vue'),meta:['客户关系管理系统','商机管理']},
      {path: 'crm_bidding_management',                  name: 'crm_bidding_management',                  component:()=>import('../views/crmSystem/crm_bidding_management.vue'),meta:['客户关系管理系统','投标管理']},
      {path: 'crm_winning_bid_management',                  name: 'crm_winning_bid_management',                  component:()=>import('../views/crmSystem/crm_winning_bid_management.vue'),meta:['客户关系管理系统','中标管理']},
      {path: 'crm_office_management',                  name: 'crm_office_management',                  component:()=>import('../views/crmSystem/crm_office_management.vue'),meta:['客户关系管理系统','事务管理']},
      {path: 'crm_pending_transaction',                  name: 'crm_pending_transaction',                  component:()=>import('../views/crmSystem/crm_pending_transaction.vue'),meta:['客户关系管理系统','待签事务']},
      {path: 'crm_model_management',                  name: 'crm_model_management',                  component:()=>import('../views/crmSystem/crm_model_management.vue'),meta:['客户关系管理系统','模型管理']},
      {path: 'crm_user_management',                  name: 'crm_user_management',                  component:()=>import('../views/crmSystem/crm_user_management.vue'),meta:['客户关系管理系统','用户管理']},
      {path: 'crm_divisional_management',                  name: 'crm_divisional_management',                  component:()=>import('../views/crmSystem/crm_divisional_management.vue'),meta:['客户关系管理系统','部门管理']},
      {path: 'crm_dictionary_management',                  name: 'crm_dictionary_management',                  component:()=>import('../views/crmSystem/crm_dictionary_management.vue'),meta:['客户关系管理系统','字典管理']},
      {path: 'crm_menu_management',                  name: 'crm_menu_management',                  component:()=>import('../views/crmSystem/crm_menu_management.vue'),meta:['客户关系管理系统','菜单管理']},
      {path: 'crm_role_management',                  name: 'crm_role_management',                  component:()=>import('../views/crmSystem/crm_role_management.vue'),meta:['客户关系管理系统','角色管理']},
      {path: 'crm_post_management',                  name: 'crm_post_management',                  component:()=>import('../views/crmSystem/crm_post_management.vue'),meta:['客户关系管理系统','岗位管理']},
      {path: 'crm_contract_management',                  name: 'crm_contract_management',                  component:()=>import('../views/crmSystem/crm_contract_management.vue'),meta:['客户关系管理系统','合同管理']},
      {path: 'crm_accessory_management',                  name: 'crm_accessory_management',                  component:()=>import('../views/crmSystem/crm_accessory_management.vue'),meta:['客户关系管理系统','附件管理']},
    ]
  },


  {//知识库
    path: '/knowledgeBaseSystem',                          name: 'knowledgeBaseSystem',                     component:()=>import('../components/stonghrSysMenu/knowledgeBaseSystem.vue'),redirect:'knowledgeBaseSystem/knowledgeBaseSystemHome',
    children: [
      {path: 'knowledgeBaseSystemHome',                    name: 'knowledgeBaseSystemHome',                 component:()=>import('../views/knowledgeBaseSystem/home/knowledgeBaseSystemHome.vue')},
      {path: 'companySystemManage',                        name: 'companySystemManage',                     component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/companySystem/companySystemManage.vue'),meta:['员工入职','公司制度管理']},
      {path: 'inductionGuideManage',                       name: 'inductionGuideManage',                    component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/inductionGuide/inductionGuideManage.vue'),meta:['员工入职','入职指南管理']},
      {path: 'operationInstructionManage',                 name: 'operationInstructionManage',              component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/operationInstruction/operationInstructionManage.vue'),meta:['员工入职','作业指导书管理']},
      {path: 'companyIntroductionManage',                  name: 'companyIntroductionManage',               component:()=>import('../views/knowledgeBaseSystem/marketingManagement/companyIntroduction/companyIntroductionManage.vue'),meta:['市场营销','公司介绍管理']},
      {path: 'productIntroductionManage',                  name: 'productIntroductionManage',               component:()=>import('../views/knowledgeBaseSystem/marketingManagement/productIntroduction/productIntroductionManage.vue'),meta:['市场营销','产品介绍管理']},
      {path: 'contractTemplateManage',                     name: 'contractTemplateManage',                  component:()=>import('../views/knowledgeBaseSystem/marketingManagement/contractTemplate/contractTemplateManage.vue'),meta:['市场营销','合同模板管理']},
      {path: 'quotationSystemManage',                      name: 'quotationSystemManage',                   component:()=>import('../views/knowledgeBaseSystem/marketingManagement/quotationSystem/quotationSystemManage.vue'),meta:['市场营销','报价体系管理']},
      {path: 'reimbursementRegulationManage',              name: 'reimbursementRegulationManage',           component:()=>import('../views/knowledgeBaseSystem/financialManagement/reimbursementRegulation/reimbursementRegulationManage.vue'),meta:['财务管理','报销规定管理']},
      {path: 'individualTaxPolicyManage',                  name: 'individualTaxPolicyManage',               component:()=>import('../views/knowledgeBaseSystem/financialManagement/individualTaxPolicy/individualTaxPolicyManage.vue'),meta:['财务管理','个税政策管理']},
      {path: 'financialKnowledgeManage',                   name: 'financialKnowledgeManage',                component:()=>import('../views/knowledgeBaseSystem/financialManagement/financialKnowledge/financialKnowledgeManage.vue'),meta:['财务管理','财务知识管理']},
      {path: 'socialInsurancePackage',                     name: 'socialInsurancePackage',            component:()=>import('../views/knowledgeBaseSystem/socialInsurancePolicy/socialInsurancePackage/socialInsurancePackage.vue'),meta:['社保政策','社保包']},
      {path: 'injuryRegulationManage',                     name: 'injuryRegulationManage',                  component:()=>import('../views/knowledgeBaseSystem/socialInsurancePolicy/injuryRegulation/injuryRegulationManage.vue'),meta:['社保政策','工伤条例规定管理']},
      {path: 'socialReimbursementRegulationManage',        name: 'socialReimbursementRegulationManage',     component:()=>import('../views/knowledgeBaseSystem/socialInsurancePolicy/socialReimbursementRegulation/socialReimbursementRegulationManage.vue'),meta:['社保政策','报销规定管理']},
      {path: 'providentFundPackage',                       name: 'providentFundPackage',              component:()=>import('../views/knowledgeBaseSystem/providentFundPolicy/providentFundPackage/providentFundPackage.vue'),meta:['公积金政策','公积金包']},
      {path: 'providentFundExtractionManage',              name: 'providentFundExtractionManage',           component:()=>import('../views/knowledgeBaseSystem/providentFundPolicy/providentFundExtraction/providentFundExtractionManage.vue'),meta:['公积金政策','公积金提取管理']},
      {path: 'retirementManage',                           name: 'retirementManage',                        component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/retirement/retirementManage.vue'),meta:['法律法规','劳动关系法','入离职、退休管理']},
      {path: 'salaryAndSocialSecurityManage',              name: 'salaryAndSocialSecurityManage',           component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/salaryAndSocialSecurity/salaryAndSocialSecurityManage.vue'),meta:['法律法规','劳动关系法','工资、社保管理']},
      {path: 'industrialInjuryAndDiseaseManage',           name: 'industrialInjuryAndDiseaseManage',        component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/IndustrialInjuryAndDisease/IndustrialInjuryAndDiseaseManage.vue'),meta:['法律法规','劳动关系法','工伤、疾病管理']},
      {path: 'femaleLaborProtectionManage',                name: 'femaleLaborProtectionManage',             component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/femaleLaborProtection/femaleLaborProtectionManage.vue'),meta:['法律法规','劳动关系法','女职工劳动保护管理']},
      {path: 'laborArbitrationAndLitigationManage',        name: 'laborArbitrationAndLitigationManage',     component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/laborArbitrationAndLitigation/laborArbitrationAndLitigationManage.vue'),meta:['法律法规','劳动关系法','劳动仲裁、诉讼管理']},
      {path: 'otherProvisionManage',                       name: 'otherProvisionManage',                    component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/otherProvision/otherProvisionManage.vue'),meta:['法律法规','劳动关系法','其他规定管理']},
      {path: 'laborRelationManage',                        name: 'laborRelationManage',                     component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelation/laborRelationManage.vue'),meta:['法律法规','劳务关系类管理']},
      {path: 'commercialLawAndEconomicLawManage',          name: 'commercialLawAndEconomicLawManage',       component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/commercialLawAndEconomicLaw/commercialLawAndEconomicLawManage.vue'),meta:['法律法规','商法、经济法类管理']},
      {path: 'internetAndIntellectualPropertyManage',      name: 'internetAndIntellectualPropertyManage',   component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/internetAndIntellectualProperty/internetAndIntellectualPropertyManage.vue'),meta:['法律法规','互联网、知识产权类管理']},
      {path: 'otherLawsAndRegulationsManage',              name: 'otherLawsAndRegulationsManage',           component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/otherLawsAndRegulations/otherLawsAndRegulationsManage.vue'),meta:['法律法规','其他法律法规管理']},
      {path: 'specializedIssuesManage',                    name: 'specializedIssuesManage',                 component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/specializedIssues/specializedIssuesManage.vue'),meta:['法律法规','专门问题研究管理']},



      {path: 'companySystemAudit',                         name: 'companySystemAudit',                     component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/companySystem/companySystemAudit.vue'),meta:['员工入职','公司制度审核']},
      {path: 'inductionGuideAudit',                        name: 'inductionGuideAudit',                    component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/inductionGuide/inductionGuideAudit.vue'),meta:['员工入职','入职指南审核']},
      {path: 'operationInstructionAudit',                  name: 'operationInstructionAudit',              component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/operationInstruction/operationInstructionAudit.vue'),meta:['员工入职','作业指导书审核']},
      {path: 'companyIntroductionAudit',                   name: 'companyIntroductionAudit',               component:()=>import('../views/knowledgeBaseSystem/marketingManagement/companyIntroduction/companyIntroductionAudit.vue'),meta:['市场营销','公司介绍审核']},
      {path: 'productIntroductionAudit',                   name: 'productIntroductionAudit',               component:()=>import('../views/knowledgeBaseSystem/marketingManagement/productIntroduction/productIntroductionAudit.vue'),meta:['市场营销','产品介绍审核']},
   	  {path: 'contractTemplateAudit',                      name: 'contractTemplateAudit',                  component:()=>import('../views/knowledgeBaseSystem/marketingManagement/contractTemplate/contractTemplateAudit.vue'),meta:['市场营销','合同模板审核']},
      {path: 'quotationSystemAudit',                       name: 'quotationSystemAudit',                   component:()=>import('../views/knowledgeBaseSystem/marketingManagement/quotationSystem/quotationSystemAudit.vue'),meta:['市场营销','报价体系审核']},
      {path: 'reimbursementRegulationAudit',               name: 'reimbursementRegulationAudit',           component:()=>import('../views/knowledgeBaseSystem/financialManagement/reimbursementRegulation/reimbursementRegulationAudit.vue'),meta:['财务管理','报销规定审核']},
      {path: 'individualTaxPolicyAudit',                   name: 'individualTaxPolicyAudit',               component:()=>import('../views/knowledgeBaseSystem/financialManagement/individualTaxPolicy/individualTaxPolicyAudit.vue'),meta:['财务管理','个税政策审核']},
      {path: 'financialKnowledgeAudit',                    name: 'financialKnowledgeAudit',                component:()=>import('../views/knowledgeBaseSystem/financialManagement/financialKnowledge/financialKnowledgeAudit.vue'),meta:['财务管理','财务知识审核']},
      {path: 'injuryRegulationAudit',                      name: 'injuryRegulationAudit',                  component:()=>import('../views/knowledgeBaseSystem/socialInsurancePolicy/injuryRegulation/injuryRegulationAudit.vue'),meta:['社保政策','工伤条例规定审核']},
      {path: 'socialReimbursementRegulationAudit',         name: 'socialReimbursementRegulationAudit',     component:()=>import('../views/knowledgeBaseSystem/socialInsurancePolicy/socialReimbursementRegulation/socialReimbursementRegulationAudit.vue'),meta:['社保政策','报销规定审核']},
      {path: 'providentFundExtractionAudit',               name: 'providentFundExtractionAudit',           component:()=>import('../views/knowledgeBaseSystem/providentFundPolicy/providentFundExtraction/providentFundExtractionAudit.vue'),meta:['公积金政策','公积金提取审核']},
      {path: 'retirementAudit',                            name: 'retirementAudit',                        component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/retirement/retirementAudit.vue'),meta:['法律法规','劳动关系法','入离职、退休审核']},
      {path: 'salaryAndSocialSecurityAudit',               name: 'salaryAndSocialSecurityAudit',           component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/salaryAndSocialSecurity/salaryAndSocialSecurityAudit.vue'),meta:['法律法规','劳动关系法','工资、社保审核']},
      {path: 'industrialInjuryAndDiseaseAudit',            name: 'industrialInjuryAndDiseaseAudit',        component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/IndustrialInjuryAndDisease/IndustrialInjuryAndDiseaseAudit.vue'),meta:['法律法规','劳动关系法','工伤、疾病审核']},
      {path: 'femaleLaborProtectionAudit',                 name: 'femaleLaborProtectionAudit',             component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/femaleLaborProtection/femaleLaborProtectionAudit.vue'),meta:['法律法规','劳动关系法','女职工劳动保护审核']},
      {path: 'laborArbitrationAndLitigationAudit',         name: 'laborArbitrationAndLitigationAudit',     component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/laborArbitrationAndLitigation/laborArbitrationAndLitigationAudit.vue'),meta:['法律法规','劳动关系法','劳动仲裁、诉讼审核']},
      {path: 'otherProvisionAudit',                        name: 'otherProvisionAudit',                    component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/otherProvision/otherProvisionAudit.vue'),meta:['法律法规','劳动关系法','其他规定审核']},
      {path: 'laborRelationAudit',                         name: 'laborRelationAudit',                     component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelation/laborRelationAudit.vue'),meta:['法律法规','劳务关系类审核']},
      {path: 'commercialLawAndEconomicLawAudit',           name: 'commercialLawAndEconomicLawAudit',       component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/commercialLawAndEconomicLaw/commercialLawAndEconomicLawAudit.vue'),meta:['法律法规','商法、经济法类审核']},
      {path: 'internetAndIntellectualPropertyAudit',       name: 'internetAndIntellectualPropertyAudit',   component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/internetAndIntellectualProperty/internetAndIntellectualPropertyAudit.vue'),meta:['法律法规','互联网、知识产权类审核']},
      {path: 'otherLawsAndRegulationsAudit',               name: 'otherLawsAndRegulationsAudit',           component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/otherLawsAndRegulations/otherLawsAndRegulationsAudit.vue'),meta:['法律法规','其他法律法规审核']},
      {path: 'specializedIssuesAudit',                     name: 'specializedIssuesAudit',                 component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/specializedIssues/specializedIssuesAudit.vue'),meta:['法律法规','专门问题研究审核']},


      {path: 'companySystem',                              name: 'companySystem',                     component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/companySystem/companySystem.vue'),meta:['员工入职','公司制度']},
      {path: 'inductionGuide',                             name: 'inductionGuide',                    component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/inductionGuide/inductionGuide.vue'),meta:['员工入职','入职指南']},
      {path: 'operationInstruction',                       name: 'operationInstruction',              component:()=>import('../views/knowledgeBaseSystem/staffRecruitModule/operationInstruction/operationInstruction.vue'),meta:['员工入职','作业指导书']},
      {path: 'companyIntroduction',                        name: 'companyIntroduction',               component:()=>import('../views/knowledgeBaseSystem/marketingManagement/companyIntroduction/companyIntroduction.vue'),meta:['市场营销','公司介绍']},
      {path: 'productIntroduction',                        name: 'productIntroduction',               component:()=>import('../views/knowledgeBaseSystem/marketingManagement/productIntroduction/productIntroduction.vue'),meta:['市场营销','产品介绍']},
      {path: 'contractTemplate',                           name: 'contractTemplate',                  component:()=>import('../views/knowledgeBaseSystem/marketingManagement/contractTemplate/contractTemplate.vue'),meta:['市场营销','合同模板']},
      {path: 'quotationSystem',                            name: 'quotationSystem',                   component:()=>import('../views/knowledgeBaseSystem/marketingManagement/quotationSystem/quotationSystem.vue'),meta:['市场营销','报价体系']},
      {path: 'reimbursementRegulation',                    name: 'reimbursementRegulation',           component:()=>import('../views/knowledgeBaseSystem/financialManagement/reimbursementRegulation/reimbursementRegulation.vue'),meta:['财务管理','报销规定']},
      {path: 'individualTaxPolicy',                        name: 'individualTaxPolicy',               component:()=>import('../views/knowledgeBaseSystem/financialManagement/individualTaxPolicy/individualTaxPolicy.vue'),meta:['财务管理','个税政策']},
      {path: 'financialKnowledge',               	         name: 'financialKnowledge',                component:()=>import('../views/knowledgeBaseSystem/financialManagement/financialKnowledge/financialKnowledge.vue'),meta:['财务管理','财务知识']},
      {path: 'injuryRegulation',                           name: 'injuryRegulation',                  component:()=>import('../views/knowledgeBaseSystem/socialInsurancePolicy/injuryRegulation/injuryRegulation.vue'),meta:['社保政策','工伤条例规定']},
      {path: 'socialReimbursementRegulation',              name: 'socialReimbursementRegulation',     component:()=>import('../views/knowledgeBaseSystem/socialInsurancePolicy/socialReimbursementRegulation/socialReimbursementRegulation.vue'),meta:['社保政策','报销规定']},
      {path: 'providentFundExtraction',                    name: 'providentFundExtraction',           component:()=>import('../views/knowledgeBaseSystem/providentFundPolicy/providentFundExtraction/providentFundExtraction.vue'),meta:['公积金政策','公积金提取']},
      {path: 'retirement',                                 name: 'retirement',                        component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/retirement/retirement.vue'),meta:['法律法规','劳动关系类','入离职、退休']},
      {path: 'salaryAndSocialSecurity',                    name: 'salaryAndSocialSecurity',           component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/salaryAndSocialSecurity/salaryAndSocialSecurity.vue'),meta:['法律法规','劳动关系类','工资、社保']},
      {path: 'industrialInjuryAndDisease',                 name: 'industrialInjuryAndDisease',        component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/IndustrialInjuryAndDisease/IndustrialInjuryAndDisease.vue'),meta:['法律法规','劳动关系类','工伤、疾病']},
      {path: 'femaleLaborProtection',                      name: 'femaleLaborProtection',             component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/femaleLaborProtection/femaleLaborProtection.vue'),meta:['法律法规','劳动关系类','女职工劳动保护']},
      {path: 'laborArbitrationAndLitigation',              name: 'laborArbitrationAndLitigation',     component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/laborArbitrationAndLitigation/laborArbitrationAndLitigation.vue'),meta:['法律法规','劳动关系类','劳动仲裁、诉讼']},
      {path: 'otherProvision',                             name: 'otherProvision',                    component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelationsLaw/otherProvision/otherProvision.vue'),meta:['法律法规','劳动关系类','其他规定']},
      {path: 'laborRelation',                              name: 'laborRelation',                     component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/laborRelation/laborRelation.vue'),meta:['法律法规','劳务关系类']},
      {path: 'commercialLawAndEconomicLaw',                name: 'commercialLawAndEconomicLaw',       component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/commercialLawAndEconomicLaw/commercialLawAndEconomicLaw.vue'),meta:['法律法规','商法、经济法类']},
      {path: 'internetAndIntellectualProperty',            name: 'internetAndIntellectualProperty',   component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/internetAndIntellectualProperty/internetAndIntellectualProperty.vue'),meta:['法律法规','互联网、知识产权类']},
      {path: 'otherLawsAndRegulations',                    name: 'otherLawsAndRegulations',           component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/otherLawsAndRegulations/otherLawsAndRegulations.vue'),meta:['法律法规','其他法律法规']},
      {path: 'specializedIssues',                          name: 'specializedIssues',                 component:()=>import('../views/knowledgeBaseSystem/lawAndRegulation/specializedIssues/specializedIssues.vue'),meta:['法律法规','专门问题研究']},
      {path: 'icdcRule',                                   name: 'icdcRule',                          component:()=>import('../views/knowledgeBaseSystem/socialInsurancePolicy/icdcRule/icdcRule.vue'),meta:['社保政策','社保公积金操作规则']},

      {path: 'companyQualification',                       name: 'companyQualification',              component:()=>import('../views/knowledgeBaseSystem/tenderDataBase/companyInformationModule/companyQualification/companyQualification.vue'),meta:['投标资料库','公司信息','公司资质']},
      {path: 'acquisitionAsset',                           name: 'acquisitionAsset',                  component:()=>import('../views/knowledgeBaseSystem/tenderDataBase/companyInformationModule/acquisitionAsset/acquisitionAsset.vue'),meta:['投标资料库','公司信息','购置资产']},
      {path: 'residentAgency',                             name: 'residentAgency',                    component:()=>import('../views/knowledgeBaseSystem/tenderDataBase/companyInformationModule/residentAgency/residentAgency.vue'),meta:['投标资料库','公司信息','驻地机构']},
      {path: 'staffInfoZTB',                               name: 'staffInfoZTB',                      component:()=>import('../views/knowledgeBaseSystem/tenderDataBase/staffInfoZTBModule/staffInfoZTB.vue'),meta:['投标资料库','人员信息']},

    ]
  },



  {//客户服务系统
    path: '/clientSystem',                      name: 'clientSystem',                    component:()=>import('../components/stonghrSysMenu/clientSystem.vue'), redirect:'clientSystem/customerHome',
    children: [
      {path: 'c_customerDeliveryPersonnel',     name: 'c_customerDeliveryPersonnel',     component:()=>import('../views/customerSystem/customerDeliveryPersonnel/c_customerDeliveryPersonnel.vue'),meta:['客户交付人员审批表','客户交付人员审批表']},//电子证明模板管理
      {path: 'c_customerWageDetails',           name: 'c_customerWageDetails',           component:()=>import('../views/customerSystem/customerWageDetails/c_customerWageDetails.vue'),meta:['客户交付人员审批表','客户交付人员审批表']},//电子证明模板管理
      {path: 'welcome',                         name: 'welcome',                         component:()=>import('../views/others/welcome/welcome.vue')},
      {path: 'programming9',                    name: 'programming9',                    component:()=>import('../views/others/programming/programming.vue')},
      {path: 'customerHome',                    name: 'customerHome',                    component:()=>import('../views/customerServiceSystem/home/customerHome'),meta: ['首页']},
      {path: 'customerHomeGZTF',                name: 'customerHomeGZTF',            component:()=>import('../views/customerServiceSystem/home/customerHomeGZTF'),meta: ['主页']},
      {path: 'c_staffinfo',                     name: 'c_staffinfo',                     component:()=>import('../views/customerServiceSystem/staffInfo/c_staffinfo.vue'),meta:['员工管理','员工花名册']},
      {path: 'c_staffcontractinfo',             name: 'c_staffcontractinfo',             component:()=>import('../views/customerServiceSystem/staffContractInfo/c_staffcontractinfo.vue'),meta:['员工管理','劳动关系信息']},//合同信息2 20190226
      {
        path: 'c_staffInsurance',
        name: 'c_staffInsurance',
        component: () => import('../views/staffSystem/ProvidentFundManagement/externalInterface/staffInsurance.vue'),
        meta: ['社保公积金', '社保在缴帐查询']
      },//员工保险
      {
        path: 'c_accmulationFund',
        name: 'c_accmulationFund',
        component: () => import('../views/staffSystem/ProvidentFundManagement/externalInterface/accumulationFund.vue'),
        meta: ['社保公积金', '公积金在缴帐查询']
      },//员工公金
      {
        path: 'c_checkwagespage',
        name: 'c_checkwagespage',
        component: () => import('../views/customerServiceSystem/staffWages/checkwages.vue'),
        meta: ['薪酬管理', '工资条信息']
      },//工资信息
      {
        path: 'c_findFinancialStaffAverageWage',
        name: 'c_findFinancialStaffAverageWage',
        component: () => import('../views/staffSystem/staffWageManageModule/financialStaffAverageWage/financialStaffAverageWage.vue'),
        meta: ['薪酬管理', '平均工资']
      },//平均实发工资
      {
        path: 'c_staffContractTODO',
        name: 'c_staffContractTODO',
        component: () => import('../views/customerServiceSystem/staffContractTODO/c_staffContractTODO.vue'),
        meta: ['劳动合同待办']
      },//劳动合同代办
      {
        path: 'c_registeredPartyMember',
        name: 'c_registeredPartyMember',
        component: () => import('../views/customerServiceSystem/staffPartyMemberManage/registeredPartyMember/c_registeredPartyMember.vue'),
        meta: ['在册党员信息']
      },//在册党员信息
      {
        path: 'c_transferredPartyMember',
        name: 'c_transferredPartyMember',
        component: () => import('../views/customerServiceSystem/staffPartyMemberManage/transferredPartyMember/c_transferredPartyMember.vue'),
        meta: ['转出党员信息']
      },//转出党员信息
      {
        path: 'c_registeredPersonnelFile',
        name: 'c_registeredPersonnelFile',
        component: () => import('../views/customerServiceSystem/staffPersonnelFileManage/registeredPersonnelFile/c_registeredPersonnelFile.vue'),
        meta: ['人事档案管理', '在库人事档案台账']
      },//在库人事档案台账
      {
        path: 'c_transferredPersonnelFile',
        name: 'c_transferredPersonnelFile',
        component: () => import('../views/customerServiceSystem/staffPersonnelFileManage/transferredPersonnelFile/c_transferredPersonnelFile.vue'),
        meta: ['人事档案管理', '转出人事档案台账']
      },//转出人事档案台账
      {
        path: 'c_staffCost',
        name: 'c_staffCost',
        component: () => import('../views/customerServiceSystem/financialStaffCost/c_staffCost.vue'),
        meta: ['薪酬管理', '人工成本']
      },//人工成本
      {
        path: 'c_dimissionCertify',
        name: 'c_dimissionCertify',
        component: () => import('../views/customerSystem/customerDimission/c_dimissionCertify.vue'),
        meta: ['员工管理', '员工离职审核（客户部门）']
      },//离职审核
      {
        path: 'c_dimissionCertifySec',
        name: 'c_dimissionCertifySec',
        component: () => import('../views/customerSystem/customerDimission/c_dimissionCertifySec.vue'),
        meta: ['员工管理', '员工离职审核（客户分公司）']
      },//离职审核
      {
        path: 'c_dimissionCertifyManage',
        name: 'c_dimissionCertifyManage',
        component: () => import('../views/customerSystem/customerDimission/c_dimissionCertifyManage.vue'),
        meta: ['员工管理', '员工离职审核（客户部门）']
      },//离职审核
      {
        path: 'c_dimissionCertifySecManage',
        name: 'c_dimissionCertifySecManage',
        component: () => import('../views/customerSystem/customerDimission/c_dimissionCertifySecManage.vue'),
        meta: ['员工管理', '员工离职审核（客户分公司）']
      },//离职审核
      {
        path: 'c_newsreview',
        name: 'c_newsreview',
        component: () => import('../views/customerSystem/customerDimission/c_newsreview.vue'),
        meta: ['员工管理', '员工入职审核(客户部门)']
      },//离职审核
      {
        path: 'c_newsreviewSec',
        name: 'c_newsreviewSec',
        component: () => import('../views/customerSystem/customerDimission/c_newsreviewSec.vue'),
        meta: ['员工管理', '员工入职审核（客户分公司）']
      },//离职审核
      {
        path: 'c_staffInfoDetail',
        name: 'c_staffInfoDetail',
        component: () => import('../views/customerServiceSystem/staffInfo/staffInfoDetail/c_staffInfoDetail.vue'),
        children: [
          {
            path: 'c_staffBaseInfo',
            name: 'c_staffinfo',
            component: () => import('../views/customerServiceSystem/staffInfo/staffInfoDetail/c_staffBaseInfo.vue')
          },//基本信息
          {
            path: 'c_staffCertificatesInfo',
            name: 'c_staffinfo',
            component: () => import('../views/customerServiceSystem/staffInfo/staffInfoDetail/c_staffCertificatesInfo.vue')
          },//证件信息
          {
            path: 'c_staffContractsInfo',
            name: 'c_staffinfo',
            component: () => import('../views/customerServiceSystem/staffInfo/staffInfoDetail/c_staffContractsInfo.vue')
          },//合同信息
          {
            path: 'c_staffWagesInfo',
            name: 'c_staffinfo',
            component: () => import('../views/customerServiceSystem/staffInfo/staffInfoDetail/c_staffWagesInfo.vue')
          },//合同信息
          {
            path: 'c_staffSpecialDeduction',
            name: 'c_staffinfo',
            component: () => import('../views/customerServiceSystem/staffInfo/staffInfoDetail/c_staffSpecialDeduction.vue')
          },//专项扣除信息
        ]
      },
      {
        path: 'c_staffContractTODOManagement',
        name: 'c_staffContractTODOManagement',
        component: () => import('../views/customerServiceSystem/staffContractTODO/c_staffContractTODOManagement.vue'),
        meta: ['员工管理', '劳动合同待办信息']
      },
      {
        path: 'c_staffFullTimeContractTODOManagement',
        name: 'c_staffFullTimeContractTODOManagement',
        component: () => import('../views/customerServiceSystem/staffContractTODO/c_staffFullTimeContractTODOManagement.vue'),
        meta: ['员工管理', '全日制劳动合同异常']
      },
      {
        path: 'c_certificateReview',
        name: 'c_certificateReview',
        component: () => import('../views/customerServiceSystem/certificateReview/c_certificateReview.vue'),
        meta: ['员工管理', '证明未审核']
      },
      {
        path: 'c_staffInfoChangeReview',
        name: 'c_staffInfoChangeReview',
        component: () => import('../views/customerServiceSystem/staffInfo/c_staffInfoChangeReview.vue'),
        meta: ['员工管理', '资料修改审核（客户部门）']
      },


    ]
  },

  {//灵工客户服务系统
    path: '/clientSystemLG',                      name: 'clientSystemLG',                component:()=>import('../components/stonghrSysMenu/clientSystemLG.vue'),
  },

  {//福利客户服务系统
    path: '/clientSystemWelfare',                      name: 'clientSystemWelfare',                component:()=>import('../components/stonghrSysMenu/clientSystemWelfare.vue'),
  },


  {//南方电信规划设计院珠海分院服务系统
    path: '/clientSystemForNFDX',               name: 'clientSystemForNFDX',             component:()=>import('../components/stonghrSysMenu/clientSystemForNFDX.vue'), redirect:'clientSystemForNFDX/customerCompanyStaffWageManage',
    children: [
      {path: 'customerCompanyStaffWageManage',                         name: 'customerCompanyStaffWageManage',                         component:()=>import('../views/clientSystemForNFDX/customerCompanyStaffWageManage/customerCompanyStaffWageManage/customerCompanyStaffWageManage.vue'), meta:['工资条管理']},
    ]
  },


]

export default routers




// WEBPACK FOOTER //
// ./src/router/routers.js